import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Image, ActionSheetIOS, Platform, Dimensions, Pressable } from 'react-native';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import { LinearGradient } from 'expo-linear-gradient';
import CS from '../../../constants/Styles';
import Colors from '../../../constants/Colors';
import Images from '../../../constants/Images';
import { addressToolTip } from '../../../constants/Arrays';
import { Loader, LoaderSmall, Button, BackgroundGradient, TextInputContainer, AddressPicker, PhotosDocumentsAddPreviewGrid, Validate, ToggleButtons, SafeAreaView, CachedImage, Alert, ToolTipWrapper, PlayVideoButton, ULItem } from '../../../components';
import { ProjectMilestone, ProjectLockOverlay, ProjectHistory, DeclineChangeModal, TermsModal } from '../../../components/Projects';
import UserAvatar from '../../../components/Users/UserAvatar';
import * as rtApi from '../../../components/Api';
import * as ImagePicker from 'expo-image-picker';
import { Camera } from 'expo-camera';
import Constants from 'expo-constants';
import { Entypo, Ionicons, FontAwesome, FontAwesome5, MaterialCommunityIcons, AntDesign } from '@expo/vector-icons';
import { getImageFieldsForUpload, formatAmount, formatCurrency, formatPercentDisplay, formatPercent, stripPhoneNumber, manipulateImage, showAlert, dataUrlToFile, isImageExtensionValid } from '../../../utils/Functions';
import DraggableFlatList from 'react-native-draggable-flatlist';
import UserState from '../../../src/contexts/UserState';
import * as SMS from 'expo-sms';
import * as MailComposer from 'expo-mail-composer';
import * as Linking from 'expo-linking';
import * as Contacts from 'expo-contacts';
import i18n from 'i18n-js';
import { useLinkTo } from '@react-navigation/native';
import { v4 as uuidv4 } from 'uuid';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { Video } from 'expo-av';
import { isMobile } from 'react-device-detect';

const ProjectScreen = ({ navigation, route }) => {
  const [user, setUser] = React.useContext(UserState);

  const [project, setProject] = React.useState([]);
  const [isNew, setIsNew] = React.useState(false);
  const [editing, setEditing] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [alertOptions, setAlertOptions] = React.useState({});
  const [ordering, setOrdering] = React.useState(false);
  // const [isHomeowner, setIsHomeowner] = React.useState(true);
  const [isContractor, setIsContractor] = React.useState(false);
  const [buttonDisabled, setButtonDisabled] = React.useState(false);
  const [isDirty, setIsDirty] = React.useState(false);
  const [saveButtonText, setSaveButtonText] = React.useState('Save Project');

  const [showInvite, setShowInvite] = React.useState(true);
  const [showJoin, setShowJoin] = React.useState(false);
  const [joinButtonDisabled, setJoinButtonDisabled] = React.useState(false);
  const [showSave, setShowSave] = React.useState(true);
  const [showDelete, setShowDelete] = React.useState(false);
  const [invitePending, setInvitePending] = React.useState(false);

  const [existingProject, setExistingProject] = React.useState(null); // saved version of project {}
  const [history, setHistory] = React.useState([]);
  const [encryptedId, setEncryptedId] = React.useState(null);
  const [projectId, setProjectId] = React.useState(null);
  const [projectPhoto, setProjectPhoto] = React.useState(null);
  const [projectTitle, setProjectTitle] = React.useState('');
  const [projectLocation, setProjectLocation] = React.useState('');
  const [addressPreview, setAddressPreview] = React.useState(null);
  const [projectStreetId, setProjectStreetId] = React.useState(null);
  const [projectStreetNumber, setProjectStreetNumber] = React.useState(null);
  const [projectAddressUnit, setProjectAddressUnit] = React.useState(null);
  const [projectDescription, setProjectDescription] = React.useState('');
  const [projectAcceptCreditCards, setProjectAcceptCreditCards] = React.useState('');
  // const [projectRatePayor, setProjectRatePayor] = React.useState('');
  const [inspirationPhotos, setInspirationPhotos] = React.useState([]);
  // const [inspirationDelete, setInspirationDelete] = React.useState([]);
  const [progressPhotos, setProgressPhotos] = React.useState([]);
  const [otherPhotos, setOtherPhotos] = React.useState([]);
  // const [otherDelete, setOtherDelete] = React.useState([]);
  const [projectTotal, setProjectTotal] = React.useState('');
  const [projectAmount, setProjectAmount] = React.useState(0);
  const [defaultAmountType , setDefaultAmountType] = React.useState('percent');
  const [whoPays, setWhoPays] = React.useState('50_50');
  const [acceptCreditCards, setAcceptCreditCards] = React.useState(false);
  const [stage, setStage] = React.useState('Started');
  const [mainImageUrl, setMainImageUrl] = React.useState(null);
  const [homeowner, setHomeowner] = React.useState([]);
  const [showHomeownerTile, setShowHomeownerTile] = React.useState(false);
  const [contractor, setContractor] = React.useState([]);
  const [showContractorTile, setShowContractorTile] = React.useState(false);
  const [addingContact, setAddingContact] = React.useState(false);
  const [feeEstimate, setFeeEstimate] = React.useState(null);
  const [fundCompletedTotal, setFundCompletedTotal] = React.useState(null);
  const [releaseCompletedTotal, setReleaseCompletedTotal] = React.useState(null);
  const [fundWidths, setFundWidths] = React.useState([]);
  const [releaseWidths, setReleaseWidths] = React.useState([]);
  const [fundTextSide, setFundTextSide] = React.useState('left');
  const [releaseTextSide, setReleaseTextSide] = React.useState('left');

  const [declineChangeReason, setDeclineChangeReason] = React.useState('');
  const [declineChangeAction, setDeclineChangeAction] = React.useState('');
  const [declineChangeModalVisible, setDeclineChangeModalVisible] = React.useState(false);

  const [showTermsModal, setShowTermsModal] = React.useState(null);
  const [signature, setSignature] = React.useState(null);
  const [signatureText, setSignatureText] = React.useState('');
  const [termsAction, setTermsAction] = React.useState('');

  const windowWidth = Dimensions.get('window').width;
  const video = React.useRef(null);
  const [showVideo, setShowVideo] = React.useState(false);
  const [status, setStatus] = React.useState({});
  // const [videoWebStyle, setVideoWebStyle] = React.useState({});
  const [mainImageWebStyle, setMainImageWebStyle] = React.useState({});

  // let fundTotal = 0;
  // let fundedTotal = 0;
  // let releaseTotal = 0;
  // let fundNotCompletedTotal = 0;
  const [fundTotal, setFundTotal] = React.useState(0);
  const [fundedTotal, setFundedTotal] = React.useState(0);
  const [releaseTotal, setReleaseTotal] = React.useState(0);
  const [fundNotCompletedTotal, setFundNotCompletedTotal] = React.useState(0);
  // const [milestones, setMilestones] = React.useState([]);

  let actionDeleteMainImage = false;

  let scrollRef = React.useRef(null);
  const linkTo = useLinkTo();
  const insets = useSafeAreaInsets();

  const defaultProjectImage = require('../../../assets/img/default_project.jpg');
  const defaultProjectImageCompleted = require('../../../assets/img/default_project_completed.jpg');
  const fullScopePlaceholder = [
    'Provide a complete scope of work with as much detail as possible to avoid any misunderstandings later.',
    'Include all work and material that will go into the project and the expectation of the final outcome.',
    'Include material types, brands, colour numbers/names, serial numbers, sizes and weights.',
    'Avoid subjective words such as: nice, beautiful, big, small.',
  ];

  const projectDocumentsToolTip = [
    "Upload quotes, contracts, permits, warranties, product brochures, invoices, receipts or other important PDFs or photos.",
    "These uploads are legally binding and will require the other party to agree to any changes to the photo, file or caption.",
    "Supported file formats include: jpg, png, tiff, gif, webp, pdf",
  ];

  const inspirationalPhotosToolTip = [
    "Share photos of your inspiration and ideas. Include a caption describing what the photo means to you.",
    "These photos are non-legally binding. Important documents should be uploaded to 'Project Documents' instead.",
    "Supported file formats include: jpg, png, tiff, gif, webp",
  ];

  const milestoneBlurbListItems = [
    `Agree to milestones beforehand with your ${isContractor ? 'customer' : 'contractor'}`,
    isContractor ? 'Never ask for a deposit' : "Never give a deposit",
    "Release 90% of the work completed or material delivered until the final milestone",
    "Create as many milestones as are necessary for your project",
  ]

  const defaultIsInvalid = {
    title: false,
    location: false,
    description: false,
    total: false,
  };
  const [isInvalid, setIsInvalid] = React.useState(defaultIsInvalid);
  let textInputs = {
    title: React.useRef(null),
    location: React.useRef(null),
    description: React.useRef(null),
    total: React.useRef(null),
  };

  const defaultMilestones = [
    // {
    //   sequence: 1,
    //   title: 'Fund the project',
    //   action: 'fund_the_project',
    //   amount: '',
    //   scope: '',
    //   completed: false,
    // },
    // {
    //   sequence: 1,
    //   title: 'Complete the Project',
    //   direction: 'Release',
    //   amount: '100%',
    //   amount_value: 100,
    //   amount_type: 'percent',
    //   description: '',
    //   completed: false,
    //   uuid: uuidv4(),
    //   deleted: false,
    // },
  ];
  const newDefaultMilestone = {
    sequence: 0,
    title: '',
    direction: 'Release', //fund_the_project
    amount: '',
    amount_value: 0,
    amount_type: 'percent',
    description: '',
    completed: false,
    deleted: false,
  };

  const [saveAfterReturn, setSaveAfterReturn] = React.useState(false);
  const [milestones, dispatchMilestones] = React.useReducer(milestoneReducer, defaultMilestones);
  // const milestoneReducer = (state, action) => {
  function milestoneReducer(state, action) {
    // console.log('milestoneReducer', state, action);
    let milestones = [...state];
    // console.log('milestones', milestones);
    switch(action.type){
      case 'setTitle':
        milestones.forEach((m) => {
          if (m.uuid === action.uuid) {
            m.title = action.payload;
          }
        });
        return [...milestones];
      case 'toggleAction':
        milestones.forEach((m) => {
          if (m.uuid === action.uuid){
            m.direction = action.payload;
          }
        });
        return [...milestones];
      case 'toggleAmountType':
        milestones.forEach((m) => {
          // if (m.sequence === action.sequence) {
            // change them all
            m.amount_type = action.payload;
            m.amount = '';
            m.amount_value = 0;
          // }
        });
        return [...milestones];
      case 'addMilestone':
        console.log('addNewMilestone', newDefaultMilestone);
        let m = { ...newDefaultMilestone }
        m.sequence = action.sequence;
        m.amount_type = defaultAmountType;
        m.uuid = uuidv4();
        milestones.push(m);
        console.log('addNewMilestone2', m);
        return [...milestones];
      case 'addReturnMilestone':
        console.log('addReturnMilestone');
        milestones.push(action.payload);
        return [...milestones];
      case 'setAmount':
        milestones.forEach((m) => {
          if (m.uuid === action.uuid) {
            m.amount = action.payload.amount;
            m.amount_value = action.payload.amount_value;
          }
        });
        return [...milestones];
      case 'setScope':
        milestones.forEach((m) => {
          if (m.uuid === action.uuid) {
            m.description = action.payload;
          }
        });
        return [...milestones];
      case 'orderMilestones':
        return [...action.payload];
      case 'setMilestones':
        return [...action.payload];
      case 'removeMilestone':
        // milestones = milestones.filter((m) => {
        //   return m.sequence != action.sequence;
        // });
        // milestones.forEach((m, i) => {
        //   m.sequence = i+1;
        // });
        let s = 1;
        milestones.forEach((m) => {
          if (m.uuid === action.uuid) {
            m.deleted = true;
            m.sequence = -1;
          }else{
            m.sequence = s;
            s++;
          }
        });
        console.log('new milestones: ', milestones);
        return [...milestones];
      case 'reset':
        return [];
      default:
        throw new Error('Dispatched milestoneReducer with invalid action.type');
    }
  };

  const getRandomId = () => {
    let id = Math.floor(Math.random() * 1000);
    if(milestones.filter((m) => { return m.id == id; }).length === 0){
      console.log('getRandomId()', id);
      return id;
    }
    getRandomId();
  }

  const getNewSequence = () => {
    return milestones.length + 1;
  }

  React.useEffect(() => {
    setMainImageWebStyle(mainImageStyle(windowWidth));
    if (Platform.OS === 'web') {
      const subscription = Dimensions.addEventListener('change', onChangeDimensions);
      return () => {
        subscription.remove();
        // Dimensions.removeEventListener('change', onChangeDimensions);
      }
    }

    return () => rtApi.cancel();
  }, []);
  
  React.useEffect(
    () =>
      navigation.addListener('beforeRemove', (e) => {
        console.log('beforeRemove');
        // e.preventDefault();
        // return;
        if (isDirty) {
          // Prevent default behavior of leaving the screen
          e.preventDefault();
          // promptUnsavedChanges(e);
          // Prompt the user before leaving the screen
          setAlertOptions({
            visible: true,
            title: 'Discard changes?',
            message: 'You have unsaved changes. Are you sure you want to discard them and leave the screen?',
            buttons: [
              { text: "Don't leave", style: 'cancel', onPress: () => { } },
              {
                text: 'Discard',
                style: 'destructive',
                // If the user confirmed, then we dispatch the action we blocked earlier
                // This will continue the action that had triggered the removal of the screen
                onPress: () => navigation.dispatch(e.data.action),
              },
            ]
          })
        }
        // If we don't have unsaved changes, then we don't need to do anything
        return;
      }),
    [navigation, isDirty]
  );
  const goBack = () => {
    console.log('goBack()');
    if (navigation.canGoBack()) {
      console.log('canGoBack')
      navigation.goBack();
    } else {
      console.log('linkTo')
      linkTo('/projects');
    }
  }

  React.useEffect(() => {
    console.log('useEffect projectId', route.params.projectId);
    if(route.params?.projectId){
      setOrdering(false);
      if (route.params.projectId === 'new') {
        createProject();
        setIsNew(true);
        setEditing(true);
        // setMilestones(defaultMilestones);
        dispatchMilestones({
          type: 'reset',
        });
        setProjectTitle('');
        setProjectDescription('');
        setProjectPhoto(null);
        setProjectLocation('');
        setProjectStreetId(null);
        setProjectStreetNumber(null);
        setProjectAddressUnit(null);
        setWhoPays('50_50');
        setAcceptCreditCards(false);
        setProjectTotal('');
        setProjectAmount(0);
        // setIsHomeowner(user.isContractor ? false : true);
        setIsContractor(user.isContractor ? true : false);
        setShowJoin(false);
        setShowSave(true);
        setShowDelete(false);
        setShowContractorTile(false);
        setShowHomeownerTile(false);
        setHomeowner([]);
        setContractor([]);
        setDefaultAmountType('percent');
        setHistory([]);
        setEncryptedId(null);
        setInvitePending(false);
        setIsDirty(false);
        setOtherPhotos([]);
        setProgressPhotos([]);
        setInspirationPhotos([]);
        setProjectPhoto(null);
        setSaveButtonText('Save Project');
        navigation.setOptions({ title: "New Project" });
      } else {
        setIsNew(false);
        getProject(route.params.projectId);
      }
    }
  }, [route.params.projectId]); // causing issues if after saving, going back to same project it wont update
  // }, []);

  React.useEffect(() => {
    console.log('useEffect refresh', route.params.refresh);
    if (route.params.refresh && route.params.projectId !== 'new'){
      getProject(route.params.projectId);
    }
    return rtApi.cancel();
  }, [route.params.refresh])

  React.useEffect(() => {
    console.log('useEffect sentInvitation', route.params?.sentInvitation);
    if (route.params?.sentInvitation && route.params?.sentInvitation === 'yes'){
      console.log('1');
      setShowInvite(false);
      setInvitePending(true);
    }else{
      setShowInvite(true);
      setInvitePending(false);
    }
  }, [route.params?.sentInvitation]);

  React.useEffect(() => {
    let disabled = false;
    let photos = [
      ...inspirationPhotos,
      ...progressPhotos,
      ...otherPhotos,
    ];
    for(let i=0; i<photos.length; i++){
      if(photos[i].uploading){
        disabled = true;
        break;
      }
    }
    setButtonDisabled(disabled);
  }, [inspirationPhotos, progressPhotos, otherPhotos]);

  React.useEffect(() => {
    getFeeEstimates();
  }, [fundTotal, fundNotCompletedTotal, whoPays]);

  React.useEffect(() => {
    console.log('useEffect milestones: ', milestones, saveAfterReturn);
    if(saveAfterReturn === true){
      console.log('saveAfterReturn!');
      // setTimeout(async () => {
        setSaveAfterReturn(false);
        saveProjectWrapper();
      // }, 150);
    }
  }, [milestones, saveAfterReturn])

  const getProject = async (id) => {
    console.log(`getProject(${id})`);
    setLoading(true);
    rtApi.get(`agreements/${id}`)
    // rtApi.get(`agreements/15`) 
    .then(data => {
      console.log(`getProject1`);
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      console.log('getProject2', data.agreement.pending_changes);
      if (typeof data.agreement.pending_changes === 'object' && data.agreement.pending_changes !== null) {
        console.log(`Found pending_changes`);
        if(Platform.OS === 'web'){
          linkTo(`/project/${id}/changes`);
        }else{
          navigation.replace('ProjectChanges', { projectId: data.agreement.id });
        }
      } else {
        setProjectData(data.agreement, data.join);
        console.log(`getProject2`);
        // if (callBack !== undefined && typeof callBack === 'function') {
        //   console.log(`getProject3`);
        //   // after joining project, get new version of project, process then do afterJoin()
        //   setTimeout(() => {
        //     callBack();
        //   }, 500);
        // }
      }
    }).catch(err => {
      linkTo('/projects');
    }).finally(() => {
      setLoading(false);
    });
  }
  const getFeeEstimates = () => {
    const fundNotCompletedTotal = calculateFundNotCompletedTotal();
    rtApi.get(`money/calculator?amount=${fundNotCompletedTotal}`)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      console.log('getFeeEstimates', data, whoPays, fundNotCompletedTotal);
      // setFeeEstimate({
      //   homeowner: '$0.00',
      //   '50_50': formatCurrency(data.fee + data.tax),
      //   contractor: formatCurrency(2 * (data.fee + data.tax)),
      // });
      let homeownerFee = 0;
      let bothFee = 0;
      let contractorFee = 0;
      switch (whoPays){
        case 'Homeowner':
          homeownerFee = 2 * data.fee_homeowner;
          break;
        case 'Contractor':
          contractorFee = 2 * data.fee_contractor;
          break;
        default:
          homeownerFee = data.fee_homeowner;
          contractorFee = data.fee_contractor;
          // bothFee = data.fee_homeowner;
          break;
      }
      const estimate = {
        homeowner: homeownerFee,
        '50_50': bothFee,
        contractor: contractorFee,
      }
      console.log('estimate: ', estimate, formatCurrency(estimate.homeowner));
      setFeeEstimate(estimate);
    }).catch(err => {
      console.log('getFeeEstimates catch: ', err);
    });
  }
  const createProject = () => {
    rtApi.post('agreements')
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      setProjectId(data.agreement_id);
    });
  }

  const processStages = (stages) => {
    // return stages;
    console.log('processStages1', stages);
    const currentStage = stages.find(s => s.completed === undefined);
    console.log('processStages2', currentStage);
    stages.forEach(s => {
      s.amount = formatCurrency(String(s.amount));
      s.amount_value = formatAmount(String(s.amount));
      s.amount_dollar_value = formatAmount(String(s.amount));
      s.amount_type = 'dollar';
      s.title = String(s.title);
      s.description = String(s.description);
      // s.completed = true;
      s.deleted = false;
      s.uuid = uuidv4();
      s.current = currentStage === undefined ? false : (currentStage.stage_id === s.stage_id);
    });
    console.log('processStages3', stages);
    return stages;
  }
  const isActionRequired = (project) => {
    // return stages;
    console.log('isActionRequired(): ', project)
    if(project.dispute){
      if (project.dispute.action_required){
        linkTo(`/dispute/${project.id}/action`);
      }else{
        linkTo(`/dispute/${project.id}/information`);
      }
    }else{
      project.stages.forEach(s => {
        if (s.action_required) {
          console.log('isActionRequired() action_required: ', s.action_required);
          goToMilestone({ ...s }, project);
        }
      });
    }
  }

  const setProjectData = (project, join) => {
    setEditing(false);
    setExistingProject(project);
    setHistory(project.history);
    setProjectId(project.id);
    setProjectLocation(project.address.value);
    setAddressPreview(project.address_preview);
    setProjectStreetId(project.street_id);
    setProjectStreetNumber(project.address_number);
    setProjectAddressUnit(project.address_unit);
    setProjectPhoto(null);
    setMainImageUrl(project.main_image);
    setProjectDescription(project.description.value || '');
    setProjectAcceptCreditCards(project.accept_credit_cards);
    setProjectAmount(project.amount);
    // setProjectRatePayor(project.rate_payor);
    setWhoPays(project.who_pays);
    setAcceptCreditCards(project.accept_credit_cards === 'Yes' ? true : false);
    setStage(project.stage);
    setShowJoin(join);
    setDefaultAmountType('dollar');
    setHomeowner(project.homeowner);
    setContractor(project.contractor);
    // milestones
    dispatchMilestones({
      type: 'setMilestones',
      payload: processStages(project.stages),
    });
    //terms
    setSignature(null);
    setSignatureText('');
    setShowTermsModal(false);
    setTermsAction('');

    // images
    project.inspiration.forEach(i => {
      i.existing = true;
      i.type = 'image';
      i.uploading = false;
      // i.image = 'https://dev.nethire.com/test/chad/test_main_image.png'; //testing
    });
    setInspirationPhotos(project.inspiration);
    // console.log('setInspirationPhotos(project.inspiration): ', project.inspiration);
    if(project.progress && project.progress.length > 0){
      project.progress.forEach(p => {
        p.existing = true;
        p.type = 'image';
        p.uploading = false;
      });
      setProgressPhotos(project.progress);
    }
    project.other.forEach(o => {
      o.existing = true;
      o.type = (o.type === 'file') ? 'file' : 'image';
      o.uploading = false;
    });
    setOtherPhotos(project.other);
    // console.log('setOtherPhotos(project.other): ', project.other);
    
    if(project.fee_estimate){
      setFeeEstimate(project.fee_estimate);
    }

    // join
    if(join){
      setEncryptedId(route.params.projectId)
      setShowInvite(false);
      setInvitePending(false);
      setEditing(false);
      setShowSave(false);
      setShowDelete(false);

      // isContractor
      if (user.isContractor) {
        if (project.homeowner_id === user.id) {
          // contractor is homeowner
          // setIsHomeowner(true);
          setIsContractor(false);
          setProjectTitle(project.contractor_title);
          navigation.setOptions({ title: project.contractor_title });
          setShowContractorTile(true);
        } else {
          // contractor is not homeowner
          // setIsHomeowner(false);
          setIsContractor(true);
          setProjectTitle(project.homeowner_title);
          navigation.setOptions({ title: project.homeowner_title });
          setShowHomeownerTile(true);
        }
      } else {
        // homeowner is always homeowner
        // setIsHomeowner(true);
        setIsContractor(false);
        setProjectTitle(project.contractor_title);
        navigation.setOptions({ title: project.contractor_title });
        setShowContractorTile(true);
        if(!project.contractor_id){
          // homeowner cannot join as a contractor
          setJoinButtonDisabled(true);
        }
      }
      // setShowHomeownerTile(false);
      // setShowContractorTile(false);
    }else{
      // not join
      setShowSave(true);
      setShowInvite(project.stage === 'Invite Sent' || project.stage === 'Completed' || (project.contractor_id && project.homeowner_id) ? false : true);
      setInvitePending(project.stage === 'Invite Sent' ? true : false);
      // setEditing(true);

      // delete button
      let stagesCompleted = areAnyMilestonesCompleted(project.stages);
      if (
        (!isNew && (project.contractor_id === null || project.homeowner_id === null) && project.stage !== 'Completed' && (project.homeowner_id === user.id || project.contractor_id === user.id) && !stagesCompleted)
      ){
        setShowDelete(true);
      }else{
        setShowDelete(false);
      }

      // isContractor
      if (user.isContractor) {
        if (project.homeowner_id === user.id) {
          // contractor is homeowner
          // setIsHomeowner(true);
          setIsContractor(false);
          setProjectTitle(project.homeowner_title);
          navigation.setOptions({ title: project.homeowner_title });
          setShowHomeownerTile(false);
          setShowContractorTile(project.contractor_id ? true : false);
          if(project.contractor_id){
            setSaveButtonText('Send changes to contractor');
          }
        } else {
          // contractor is not homeowner
          // setIsHomeowner(false);
          setIsContractor(true);
          setProjectTitle(project.contractor_title);
          navigation.setOptions({ title: project.contractor_title });
          setShowHomeownerTile(project.homeowner_id ? true : false);
          setShowContractorTile(false);
          if (project.homeowner_id) {
            setSaveButtonText('Send changes to homeowner');
          }
        }
      } else {
        // homeowner is always homeowner
        // setIsHomeowner(true);
        setIsContractor(false);
        setProjectTitle(project.homeowner_title);
        navigation.setOptions({ title: project.homeowner_title });
        setShowHomeownerTile(false);
        setShowContractorTile(project.contractor_id ? true : false);
        if (project.contractor_id) {
          setSaveButtonText('Send changes to contractor');
        }
      }
    }
    if(project.stage === 'Completed'){
      setEditing(false);
      setShowSave(false);
      setShowDelete(false);
      setShowInvite(false);
    }
    setTimeout(() => {
      calculateProgressBar(project.stages, project.amount);
      isActionRequired(project);
      calculateTotals(project.stages);
      // getFeeEstimates();
    }, 250);
  } // end of setProjectData

  const areAnyMilestonesCompleted = (milestones) => {
    let result = false;
    for(let i=0; i<milestones.length; i++){
      if(milestones[i].completed){
        result = true;
        break;
      }
    }
    console.log('areAnyMilestonesCompleted: ', result);
    return result;
  }

  // edit
  const toggleEditProject = () => {
    setEditing(!editing);
  }

  const onChangeProjectTitle = (title) => {
    if (isInvalid.title && title.length > 1) {
      setIsInvalid(prevState => { return { ...prevState, title: false } });
    }
    setProjectTitle(title);
    console.log('onChangeProjectTitle CHANGING TITLE...')
    navigation.setOptions({ title: title || (isNew ? 'New Project' : 'Project') });
    setIsDirty(true);
  };
  const onChangeProjectDescription = (description) => {
    if (isInvalid.description && description.length > 1) {
      setIsInvalid(prevState => { return { ...prevState, description: false } });
    }
    setProjectDescription(description);
    setIsDirty(true);
  };
  const onChangeProjectTotal = (total) => {
    console.log('onChangeProjectTotal');
    console.log(i18n.toCurrency(total));
    console.log(i18n.toCurrency(total, { precision: 2 }));
    console.log(i18n.toNumber(total));
    console.log(i18n.toNumber(total, { precision: 2, delimiter: '' }));
    // return;
    total = formatAmount(total);
    console.log('total: ', total);
    if (isInvalid.total && Validate.Amount(total)) {
      setIsInvalid(prevState => { return { ...prevState, total: false } });
    }
    setProjectTotal(total);
    setProjectAmount(total ? total : 0);
    setIsDirty(true);
  };
  const onBlurTotal = (total) => {
    setProjectTotal(formatCurrency(formatAmount(total)));
    calculateTotals();
    // getFeeEstimates();
  }
  const setIsInvalidLocation = () => {
    setIsInvalid(prevState => { return { ...prevState, location: false } });
  }

  const addNewMiletsone = () => {
    dispatchMilestones({
      type: 'addMilestone',
      sequence: getNewSequence(),
    })
    setIsDirty(true);
  }

  const promptDeleteProject = () => {
    setAlertOptions({
      visible: true,
      title: 'Confirm',
      message: 'Are you sure you want to delete this project? This action cannot be undone.',
      buttons: [
        {
          text: 'Cancel',
          onPress: () => {},
          style: 'cancel',
        },
        {
          text: 'Delete',
          onPress: () => deleteProject(),
          style: 'destructive',
        }
      ]
    })
  };
  const deleteProject = () => {
    setLoading(true);
    rtApi.remove(`agreements/${route.params.projectId}`)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      console.log('getProject', data);
      navigation.navigate('Projects');
    }).catch(err => {
      linkTo('/projects');
    }).finally(() => {
      setLoading(false);
    })
  }

  const buildFormData = () => {
    let fd = new FormData();
    // if(existingProject){
    //   fd.append('id', projectId);
    // }
    // if (isHomeowner){
    if (!isContractor){
      fd.append('homeowner_id', user.id);
      fd.append('homeowner_title', projectTitle);
    }else{
      fd.append('contractor_id', user.id);
      fd.append('contractor_title', projectTitle);
      fd.append('accept_credit_cards', projectAcceptCreditCards);
      // fd.append('rate_payor', projectRatePayor);
      fd.append('who_pays', whoPays);
      fd.append('accept_credit_cards', acceptCreditCards ? 'Yes' : 'No');
    }
    if (projectDescription){
      fd.append('description', projectDescription);
    }
    fd.append('street_id', projectStreetId);
    fd.append('address_number', projectStreetNumber);
    if(projectAddressUnit){
      fd.append('address_unit', projectAddressUnit);
    }
    // let stages = [...milestones];
    let stages = JSON.parse(JSON.stringify(milestones));
    console.log('stages: ', stages);
    fd.append('amount', calculateAmount());
    if(isNew){
      fd.append('status', 'In-Progress');
      // fd.append('amount', calculateAmount());
      // fd.append('total', formatAmount(projectTotal));
      
      let totalPercentDollarAmount = 0;
      let a = 0;
      stages.forEach((m, i) => {
        if(defaultAmountType === 'percent'){
          a = getPercentageAmount(projectTotal, m.amount_value);
          console.log('a: ', projectTotal, m.amount, a);
          m.amount = formatAmount(a);
          totalPercentDollarAmount += parseFloat(a);
        }
      });
      // add projectTotal as 1st milestone
      console.log('projectTotal: ', formatAmount(projectTotal));
      if (formatAmount(projectTotal) > 0){
        stages.unshift({
          sequence: 1,
          title: 'Fund the project',
          direction: 'Fund',
          amount: formatAmount(projectTotal),
          amount_type: 'dollar',
          description: 'Homeowner funds the project',
          completed: false,
          deleted: false,
          amount_dollar_value: formatAmount(projectTotal),
        });
      }
      console.log('stages (POST): ', stages);
      console.log('totalPercentDollarAmount, projectTotal): ', totalPercentDollarAmount, parseFloat(formatAmount(projectTotal)));
    
      //terms
      if (Platform.OS !== 'web' && signature) {
        console.log('signature: ', signature);
        let imgDetails = getImageFieldsForUpload(signature.uri);
        fd.append('signature', {
          uri: signature.uri,
          name: imgDetails.filename,
          type: imgDetails.type,
        });
      }
      if (Platform.OS === 'web' && signatureText) {
        fd.append('signature_name', signatureText);
      }
    }
    // set sequence
    let s = 1;
    stages.forEach(m => {
      if(m.deleted){
        m.sequence = -1;
        m.deleted = 'Yes';
      }else{
        m.sequence = s;
        m.deleted = 'No';
        s++;
      }
      // m.sequence = i + 1;
    });
    fd.append('milestones', JSON.stringify(stages));
    
    if(projectPhoto){
      if (Platform.OS !== 'web') {
        let imgDetails = getImageFieldsForUpload(projectPhoto.uri);
        fd.append('main_image', {
          uri: projectPhoto.uri,
          name: imgDetails.filename,
          type: imgDetails.type,
        });
      }else{
        fd.append('main_image', projectPhoto.file);
      }
    }
    // delete main image ??
    fd.append('main_image_delete', actionDeleteMainImage ? 'yes' : 'no')
  
    return fd;
  }
  const calculateAmount = () => {
    return getFundSum();
  }
  const checkProject = () => {
    console.log('checking project');
    calculateTotals();
    try {
      if (!Validate.Blank(projectTitle)) {
        // textInputs.title.current.focus();
        throw ({ message: 'Project title cannot be blank', input: textInputs.title});
      }
      if (!projectStreetId) {
        // textInputs.location.current.focus();
        throw ({ message: 'Project location cannot be blank', input: textInputs.location });
      }
    } catch (err) {
      console.log('check() catch: ', err);
      let options = { visible: true, title: 'Error', message: err.message, };
      options.buttons = [
        {
          text: 'Ok',
          onPress: () => err.input.current.focus(),
        },
      ]
      setAlertOptions(options);
      return false;
    }

    const fundTotal = calculateFundTotal();
    const releaseTotal = calculateReleaseTotal();
    console.log('checking...', fundTotal, releaseTotal, isNew, defaultAmountType);

    // Allow quotes, no total & no milestones
    if(fundTotal === 0 && releaseTotal === 0 && milestones.find(m => m.deleted === undefined || !m.deleted) === undefined){
      console.log('QUOTE');
      return true;
    }
    console.log('NOT QUOTE');

    if(isNew){
      console.log('IS NEW');
      //isNew check to make sure at least 1 release milestone has been created
      let releaseMilestone = milestones.find(m => { return m.direction === 'Release' });
      // console.log('check release: ', releaseMilestone, projectTotal, fundTotal);
      if(releaseMilestone === undefined && fundTotal > 0){
        setAlertOptions({ visible: true, title: 'Error', message: "You must create at least one milestone before continuing. If you're unsure on how to do this, check out the video above 'How to Set Up Your Milestones'.", });
        return false;
      }

      //isNew - check to make sure project fund === release
      if (defaultAmountType === 'dollar' && fundTotal !== releaseTotal){
        setAlertOptions({
          visible: true,
          title: 'Error',
          // message: `The total amount of releases (${formatCurrency(releaseTotal)}) must equal the total amount of the project (${formatCurrency(fundTotal)}).`,
          message: 'The total value of releases must equal the total cost of your project.',
        });
        return false;
      }
      if (defaultAmountType === 'percent' && releaseTotal !== 100) {
        setAlertOptions({
          visible: true,
          title: 'Error',
          // message: `The total amount of releases (${releaseTotal}%) must equal 100% when creating a new project.`,
          message: 'The total value of releases must equal 100% when creating a new project.',
        });
        return false;
      }
    }
    
    if((isNew && formatAmount(projectTotal) > 0) || !isNew){
      if(isNew && defaultAmountType === 'percent'){
        milestones.forEach(m => m.amount_dollar_value = formatAmount(projectTotal) * (m.amount_value / 100))
      }else{
        milestones.forEach(m => m.amount_dollar_value = m.amount_value )
      }
      console.log('check milestones release values', milestones);
      let invalidMilestones = milestones.find(m => { return (m.direction === 'Release' && !m.deleted && m.amount_dollar_value < 11) });
      if(invalidMilestones){
        setAlertOptions({ visible: true, title: 'Error', message: `Milestones must have a release amount of at least $11.00, the Milestone '${invalidMilestones.title}' has a release amount of ${formatCurrency(invalidMilestones.amount_dollar_value)}`, });
        return false;
      }
    }
    console.log('check() passed');
    return true;
  }
  const checkOverFunded = () => {
    const fundTotal = calculateFundTotal();
    const releaseTotal = calculateReleaseTotal();
    console.log('checking if project is overfunded', fundTotal, releaseTotal, isNew, defaultAmountType);
    return new Promise((resolve, reject) => {
      if (
        // (isNew && defaultAmountType === 'percent' && releaseTotal < 100)
        // ||
        // (defaultAmountType === 'dollar' && fundTotal !== releaseTotal)
        (defaultAmountType === 'dollar' && fundTotal !== releaseTotal && fundTotal > releaseTotal)
      ) {
        let returnMilestone = milestones.find(m => { return m.direction === 'Return' });
        if (!returnMilestone){
          let overFundedAmount = formatCurrency(fundTotal - releaseTotal);
          let options = { visible: true, title: 'Error', message: `This project is over-funded. Are you sure you want to create a milestone to return the remaining balance of ${overFundedAmount} to the homeowner?`, };
          options.buttons = [
            {
              text: 'Yes',
              onPress: () => {
                createReturnMilestone();
                // resolve(true);
                reject(false);
              }
            },
            {
              text: 'No',
              onPress: () => reject(false)
            },
          ]
          setAlertOptions(options);
        }else{
          let overFundedAmount = formatCurrency(fundTotal - releaseTotal);
          let options = { visible: true, title: 'Error', message: `More money has been funded than will be released. Are you sure you'd like to return/refund the excess amount of ${overFundedAmount} to the homeowner?`, };
          options.buttons = [
            {
              text: 'Yes',
              onPress: () => {
                editReturnMilestone();
                // resolve(true);
                reject(true);
              }
            },
            {
              text: 'No',
              onPress: () => reject(false)
            },
          ]
          setAlertOptions(options);
        }
      } else if (defaultAmountType === 'dollar' && fundTotal !== releaseTotal && fundTotal < releaseTotal){
        let overFundedAmount = formatCurrency(Math.abs(fundTotal - releaseTotal));
        let options = { visible: true, title: 'Error', message: `You cannot release more money than what has been funded. Please add an additional ${overFundedAmount} in funding to your project.`, };
        options.buttons = [
          {
            text: 'Ok',
            onPress: () => reject(false)
          },
        ]
        setAlertOptions(options);
      } else if (defaultAmountType === 'percent' && releaseTotal > 100) {
      let options = { visible: true, title: 'Error', message: `You cannot release more than 100% of the amount of the project`, };
      options.buttons = [
        {
          text: 'Ok',
          onPress: () => reject(false)
        },
      ]
      setAlertOptions(options);
    }else{
        resolve(true);
      }
    });
  }
  const createReturnMilestone = () => {
    const fundTotal = calculateFundTotal();
    const releaseTotal = calculateReleaseTotal();
    console.log('createReturnMilestone', fundTotal, fundedTotal, fundCompletedTotal, fundNotCompletedTotal, releaseTotal, releaseCompletedTotal);
    let overFundedAmount = fundTotal - releaseTotal;
    let returnMilestone = {
      sequence: milestones.length + 1,
      title: 'Return',
      direction: 'Return',
      amount: formatCurrency(overFundedAmount),
      amount_value: overFundedAmount,
      amount_type: 'dollar',
      description: 'Return the overfunded amount to the homeowner',
      completed: false,
      uuid: uuidv4(),
    }
    console.log('returnMilestone: ', returnMilestone);
    dispatchMilestones({
      type: 'addReturnMilestone',
      payload: returnMilestone,
    });
    setSaveAfterReturn(true);
  }
  const editReturnMilestone = () => {
    const fundTotal = calculateFundTotal();
    const releaseTotal = calculateReleaseTotal();
    console.log('editReturnMilestone: ', fundTotal, releaseTotal);
    let returnMilestone = milestones.find(m => { return m.direction === 'Return' });
    let uuid = returnMilestone.uuid;
    let overFundedAmount = parseFloat(returnMilestone.amount_value) + (fundTotal - releaseTotal);
    let payload = {
      amount: formatCurrency(overFundedAmount),
      amount_value: overFundedAmount,
    }
    console.log('edit payload, setAmount: ', payload, uuid, returnMilestone.amount_value)
    dispatchMilestones({
      type: 'setAmount',
      uuid: uuid,
      payload: payload,
    });
    setSaveAfterReturn(true);
  }
  const saveProject = (reload) => {
    console.log('saving project');
    // console.log('title: ', projectTitle);
    // console.log('location: ', projectLocation);
    // console.log('streetId: ', projectStreetId);
    // console.log('description: ', projectDescription);
    // console.log('milestones: ', milestones);
    // console.log('isNew: ', isNew);
    // return;
    return new Promise((resolve, reject) => {
      // if(checkProject()){
        setLoading(true);
        let fd = buildFormData();
        // return; // testing
        // let action = isNew ? 'post' : 'put';
        // let url = isNew ? 'agreements' : `agreements/${projectId}`;
        let action = 'put';
        let url = `agreements/${projectId}`;
        console.log('actionUrl', action, url);
        // return;
        // reject(false);
        rtApi[action](url, fd)
        .then(data => {
          console.log('saved project', data);
          if(data.result){
            if (reload && data.agreement) {
              setProjectData(data.agreement);
            }
            resolve(data);
          }else{
            reject(data.errors.join('; '));
          }
        }).catch(err => {
          reject(err);
        }).finally(() => {
          setLoading(false);
        });
      // }
    });
  }
  const saveProjectWrapper = async () => {
    if (checkProject()) {
      try{
        let overFundedResult = await checkOverFunded();
        console.log('overFundedResult: ', overFundedResult);
        if(overFundedResult){
          console.log('checks passed .. save now');
          // return;
          if (isNew) {
            console.log('new project, confirm terms first');
            setTermsAction('save');
            setShowTermsModal(true);
          } else {
            console.log('saveProjectWrapper()');
            // return;
            let saveResult = await saveProject(false);
            console.log('saveResult: ', saveResult);
            if (saveResult.result) {
              console.log('showAlert');
              setProjectId(null);
              showAlert('success', 'Successfully Saved', () => linkTo('/projects'));
              // navigation.navigate('Projects');
            }
          }
        }
      }catch(err){
        console.log('catch overfunded result: ', err);
      }
    }
  }

  const inviteContractor = async () => {
    console.log('Invite a contractor');
    if(checkProject()){
      if(isNew){
        console.log('new project, confirm terms first befre invite');
        setTermsAction('invite');
        setShowTermsModal(true);
      }else{
        saveThenInvite();
      }
    }
  }

  const saveThenInvite = async () => {
    let saveResult = await saveProject(true);
    console.log('invite saveResult', saveResult);
    if (saveResult.result) {
      inviteAction();
    }
  }

  const inviteAction = () => {
    setTimeout(() => {
      const fundTotal = calculateFundTotal();
      console.log('inviteAction: ', fundTotal, projectAmount);
      const role = isContractor ? 'contractor' : 'homeowner';
      if (fundTotal > 0) {
        // if (projectAmount > 0) {
        // linkTo(`/project/${projectId}/invite`);
        linkTo(`/project/${projectId}/invite?inviteType=Project&role=${role}&title=${projectTitle}&address=${projectLocation}`);
      } else {
        linkTo(`/project/${projectId}/invite?inviteType=Quote&role=${role}&title=${projectTitle}&address=${projectLocation}`)
        // inviteToQuote();
      }
    }, 50)
  }

  const inviteToQuote = () => {
    setLoading(true);
    rtApi.get(`agreements/${projectId}/quote`)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      afterInviteToQuote(data);
    }).catch(err => {
      console.log('inviteToQuote catch: ', err);
    }).finally(() => {
      setLoading(false);
    })
  }

  const afterInviteToQuote = async (data) => {
    console.log('inviteToQuote: ', data);
    let { subject, body } = data;
    const { status } = await MailComposer.composeAsync({
      recipients: [],
      subject: subject,
      body: body,
      isHtml: true,
    });
    console.log('status: ', status);
    if (status === 'sent' || Platform.OS === 'web') {
      const title = Platform.OS === 'web' ? 'Notice' : 'Success';
      const message = Platform.OS === 'web' ? "We have opened a compose email window using your system's default email client, please send the email to your contractor's email address and hit the OK button below after sending.": 'You have successfully invited contractor(s) to quote your project. We will notify you when a contractor provides a quote.';
      setAlertOptions({ visible: true, title: title, message: message });
    }
  }

  const beforeJoinProject = () => {
    // console.log('beforeJoinProject: ', projectId);
    // return;
    setTermsAction('join');
    setShowTermsModal(true);
  }
  const buildJoinFormData = () => {
    let fd = new FormData();
    if (Platform.OS !== 'web' && signature) {
      console.log('signature: ', signature);
      let imgDetails = getImageFieldsForUpload(signature.uri);
      fd.append('signature', {
        uri: signature.uri,
        name: imgDetails.filename,
        type: imgDetails.type,
      });
    }
    if (Platform.OS === 'web' && signatureText) {
      fd.append('signature_name', signatureText);
    }
    return fd;
  }
  const joinProject = () => {
    setLoading(true);
    let fd = buildJoinFormData();
    rtApi.put(`agreements/${encryptedId}/join`, fd)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      console.log('joined successfully');
      afterJoin();
      // getProject(projectId, afterJoin);
    }).catch(err => {
      console.log('Something went wrong joining the project', err);
    }).finally(() => {
      setLoading(false);
    });
  }
  const afterJoin = () => {
    console.log('afterJoin(): ', projectId);
    setShowJoin(false);
    // if(!user.isContractor || isHomeowner){
    if (!user.isContractor || !isContractor){
      // homeowner
      setAlertOptions({
        visible: true,
        title: 'Fund the Project',
        message: 'Now that you’ve joined this project, it’s time to fund it.',
        buttons: [
          {
            text: 'OK',
            onPress: () => linkTo(`/project/${projectId}`),
          }
        ],
      });
    }else{
      setAlertOptions({
        visible: true,
        title: 'Congratulations',
        message: 'You have successfully joined this project.',
        buttons: [
          {
            text: 'OK',
            onPress: () => linkTo(`/projects`),
          }
        ],
      });
    }
  }
  const promptDeclineProject = () => {
    promptDeclineChangeProject('decline');
  }
  const promptChangeProject = () => {
    promptDeclineChangeProject('change');
  }
  const promptDeclineChangeProject = (action) => {
    setDeclineChangeReason('');
    setDeclineChangeAction(action);
    setDeclineChangeModalVisible(true);
  }
  const declineChangeProject = (action) => {
    console.log('declineCahngeProject: ', action, declineChangeReason);
    // return;
    setLoading(true);
    let fd = new FormData();
    fd.append('action', action);
    if(declineChangeReason){
      fd.append('reason', declineChangeReason)
    }
    rtApi.put(`agreements/${encryptedId}/join`, fd)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      console.log(`'${action}' successfully`);
      linkTo('/projects');
    }).catch(err => {
      console.log(`Something went wrong '${action}' the project`, err);
    }).finally(() => {
      setLoading(false);
      setDeclineChangeModalVisible(false);
    });
  }

  const promptProjectPhoto = () => {
    if(Platform.OS === 'ios'){
      let options = ['Cancel', 'Take Photo', 'Choose Existing'];
      if (projectPhoto || mainImageUrl) { options.push('Remove Photo'); }
      ActionSheetIOS.showActionSheetWithOptions(
        {
          options: options,
          cancelButtonIndex: 0,
          destructiveButtonIndex: 3,
        },
        buttonIndex => {
          if (buttonIndex === 0) {
            console.log('cancel');
          } else if (buttonIndex === 1) {
            takeProjectPhoto();
          } else if (buttonIndex === 2) {
            chooseProjectPhoto();
          } else if (buttonIndex === 3) {
            deleteMainImage()
          }
        }
      );
    }else if(Platform.OS === 'android'){
      let alertButtons = [
        {
          text: 'Take Photo',
          onPress: () => takeProjectPhoto(),
        },
        {
          text: 'Choose Existing',
          onPress: () => chooseProjectPhoto(),
        },
        {
          text: 'Cancel',
          onPress: null,
        }
      ];
      if (projectPhoto || mainImageUrl) {
        alertButtons.push({
          text: 'Remove Photo',
          onPress: () => deleteMainImage(),
        })
      }
      setAlertOptions({
        visible: true,
        title: null,
        message: 'Choose an action to perform',
        buttons: alertButtons,
        dismissable: true,
      });
    }else{
      //web
      chooseProjectPhoto();
    }
  }
  const chooseProjectPhoto = async () => {
    const { status } = await ImagePicker.requestMediaLibraryPermissionsAsync();
    console.log('status: ', status);
    if (status !== 'granted') {
      setAlertOptions({ visible: true, title: 'Warning', message: 'Sorry, we need camera roll permissions to make this work!', });
    }else{
      let result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.Images,
        // allowsEditing: true,
        aspect: [Images.project.main.width, Images.project.main.height],
        quality: Images.quality,
      });
      console.log(result);
      if(!result.canceled){
        handleImageResult(result.assets[0]);
      }
    }
  }
  const takeProjectPhoto = async () => {
    if (Platform.OS !== 'web') {
      // const { status } = await ImagePicker.requestMediaLibraryPermissionsAsync();
      const { status } = await Camera.requestCameraPermissionsAsync();
      console.log('status: ', status);
      if (status !== 'granted') {
        setAlertOptions({ visible: true, title: 'Warning', message: 'Sorry, we need camera roll permissions to make this work!', });
      } else {
        let result = await ImagePicker.launchCameraAsync({
          mediaTypes: ImagePicker.MediaTypeOptions.Images,
          // allowsEditing: true,
          aspect: [Images.project.main.width, Images.project.main.height],
          quality: Images.quality,
        });
        console.log(result);
        handleImageResult(result.assets[0]);
      }
    }
  }
  const deleteMainImage = () => {
    if(projectPhoto){
      setProjectPhoto(null);
      if(existingProject.main_image){
        setMainImageUrl(existingProject.main_image);
      }
    }else{
      setMainImageUrl(null);
      actionDeleteMainImage = true;
    }
  }
  const handleImageResult = async (result) => {
    if (!result.cancelled) {
      let manipResult = await manipulateImage(result, Images.project.main.width, Images.project.main.height);
      if (Platform.OS === 'web') {
        manipResult.file = await dataUrlToFile(manipResult.uri);
      }

      const isValidExtension = isImageExtensionValid(Platform.OS === 'web' ? manipResult.file.name : manipResult.uri);
      if (!isValidExtension.result) {
        setAlertOptions({ visible: true, title: 'Error', message: `Invalid image type. Images must end in one of the following extensions: ${isValidExtension.extensions}`, });
        return;
      }

      if (!manipResult.cancelled) {
        console.log('manipResult: ', manipResult);
        setProjectPhoto(manipResult);
        setMainImageUrl(null);
        actionDeleteMainImage = false;
      }
    }
  }
  
  const getFundSum = () => {
    if(!existingProject){
      if(projectTotal){
        return parseFloat(formatAmount(projectTotal));
      }
      return 0;
    }
    return milestones.reduce((total, m) => {
      if (m.direction === 'Fund' && !m.deleted) {
        // return total + parseFloat(m.amount.replace(/[^0-9.]|\./g, ''));
        return total + parseFloat(m.amount.replace(/[^0-9.]/g, ''));
      }
      return total;
    }, 0);
  }
  const getReleaseSum = (ids) => {
    return milestones.reduce((total, m) => {
      // debugger;
      if (m.direction === 'Release' && !m.deleted) {
        if (ids !== undefined && ids.includes(m.uuid)){
          // exclude any ids in the sum
          return total;
        }
        if(m.amount){
          // return total + parseFloat(m.amount.replace(/[^0-9.]|\./g, ''));
          return total + parseFloat(m.amount.replace(/[^0-9.]/g, ''));
        }
      }
      return total;
    }, 0);
  }
  const getPercentageSum = (ids) => {
    return milestones.reduce((total, m) => {
      if (m.direction === 'Release') {
        if (ids !== undefined && ids.includes(m.sequence)) {
          // exclude any ids in the sum
          return total;
        }
        if (m.amount) {
          // return total + parseFloat(m.amount.replace(/[^0-9.]|\./g, ''));
          return total + parseInt(m.amount);
        }
      }
      return total;
    }, 0);
  }
  const onFocusAmount = (milestone) => {
    console.log('onFocusAmount1', milestone);
    if(milestone.amount_type === 'dollar'){
      // if (milestone.direction === 'Release' && (!milestone.amount || milestone.amount === '')) {
      if (milestone.direction === 'Release' && (!milestone.amount_value || milestone.amount_value === '0')) {
        let fundSum = getFundSum();
        let releaseSum = getReleaseSum();
        console.log('onFocusAmount2', fundSum, releaseSum);
        if (fundSum > releaseSum) {
          // let amount = formatAmount(String(fundSum - releaseSum));
          let payload = {
            amount: formatCurrency(fundSum - releaseSum),
            amount_value: formatAmount(fundSum - releaseSum),
          }
          console.log('onFocusAmount3', fundSum - releaseSum);
          dispatchMilestones({
            type: 'setAmount',
            uuid: milestone.uuid,
            payload: payload,
          });
        }
      }
    }else if(milestone.amount_type === 'percent'){
      if (milestone.direction === 'Release' && (!milestone.amount || milestone.amount === '')) {
        let percentSum = getPercentageSum();
        let percentSum2 = getPercentageSum([milestone.sequence]);
        let percent = 100;
        if(percentSum2 > 0){
          percent = 100 - percentSum2;
        }
        let payload = {
          amount: formatPercentDisplay(String(percent)),
          amount_type: percent,
        }
        dispatchMilestones({
          type: 'setAmount',
          uuid: milestone.uuid,
          payload: payload,
        });
      }
    }
  }
  const onBlurAmount = (milestone) => {
    console.log('onBlurAmount', milestone);
    // return;
    if(milestone.amount_type === 'dollar'){
      console.log('dispatching: ', formatCurrency(milestone.amount));
      let payload = {
        amount: formatCurrency(milestone.amount_value),
        amount_value: milestone.amount_value,
      }
      dispatchMilestones({
        type: 'setAmount',
        uuid: milestone.uuid,
        payload: payload,
      });
      console.log('onBlurAmount1', milestone);
      // this section of code restricts the amount from being more than the fund amount and set the value to the amount left to be released
      // if (milestone.direction === 'Release' && milestone.amount) {
      //   let fundSum = getFundSum();
      //   let releaseSum = getReleaseSum();
      //   console.log('onBlurAmount2', fundSum, releaseSum);
      //   if (releaseSum > fundSum) {
      //     let releaseSum2 = getReleaseSum([milestone.uuid]);
      //     let amount = formatAmount(fundSum - releaseSum2);
      //     let payload = {
      //       amount: formatCurrency(amount),
      //       amount_value: amount,
      //     }
      //     console.log('onBlurAmount3', amount);
      //     dispatchMilestones({
      //       type: 'setAmount',
      //       uuid: milestone.uuid,
      //       payload: payload,
      //     });
      //   }
      // }
    }else if(milestone.amount_type === 'percent'){
      console.log('milestone.amount_type === percent', milestone);
      let payload = {
        amount: formatPercentDisplay(milestone.amount),
        amount_value: formatAmount(milestone.amount),
      }
      dispatchMilestones({
        type: 'setAmount',
        uuid: milestone.uuid,
        payload: payload,
      });
    }
    calculateTotals();
    // getFeeEstimates();
  }

  const getPercentage = (value) => {
    console.log('getPercentage(): ', value);
    return parseInt(formatPercent(value))/100;
  }
  const getPercentageAmount = (total, percentValue) => {
    console.log('getPercentageAmount(): ', total, percentValue);
    console.log('getPercentageAmount() 2: ', formatAmount(total), getPercentage(percentValue));
    return formatAmount(formatAmount(total) * getPercentage(percentValue));
  }
  const calculateTotals = (stages) => {
    try{
      console.log('calculateTotals()');
      setFundTotal(calculateFundTotal(stages));
      setFundedTotal(calculateFundedTotal(stages));
      setReleaseTotal(calculateReleaseTotal(stages));
      setFundNotCompletedTotal(calculateFundNotCompletedTotal(stages));
    } catch(err){
      console.log('calculateTotals() catch: ', err);
    }
  }
  const calculateFundTotal = (stages) => {
    const m = (stages === undefined) ? [...milestones] : [...stages];
    let amount = 0;
    if (isNew) {
      amount = (projectTotal === '') ? 0 : parseFloat(formatAmount(projectTotal));
    } else {
      amount = m.reduce((total, m) => {
        if (m.direction === 'Fund' && !m.deleted) {
          return total + parseFloat(m.amount_value);
        }
        return total;
      }, 0);
    }
    console.log('calculateFundTotal: ', amount);
    return amount;
  }
  const calculateFundedTotal = (stages) => {
    const m = (stages === undefined) ? [...milestones] : [...stages];
    let amount = 0;
    if (isNew) {
      return 0;
    } else {
      return m.reduce((total, m) => {
        if (m.direction === 'Fund' && !m.deleted && m.completed === 'Yes') {
          return total + parseFloat(m.amount_value);
        }
        return total;
      }, 0);
    }
    console.log('calculateFundedTotal: ', amount);
    return amount;
  }
  const calculateReleaseTotal = (stages) => {
    const m = (stages === undefined) ? [...milestones] : [...stages];
    let amount = 0;
    console.log('calculateReleaseTotal: ', m);
    amount = m.reduce((total, m) => {
      if ((m.direction === 'Release' || m.direction === 'Return') && !m.deleted) {
        return total + parseFloat(m.amount_value);
      }
      return total;
    }, 0);

    console.log('calculateReleaseTotal: ', amount);
    return amount;
  }
  const calculateFundNotCompletedTotal = (stages) => {
    const m = (stages === undefined) ? [...milestones] : [...stages];
    let amount = 0;
    if (isNew) {
      amount = (projectTotal === '') ? 0 : parseFloat(formatAmount(projectTotal));
    } else {
      amount = m.reduce((total, m) => {
        if (!m.completed && m.direction === 'Fund' && !m.deleted) {
          return total + parseFloat(m.amount_value);
        }
        return total;
      }, 0);
    }
    console.log('calculateFundNotCompletedTotal: ', amount);
    return amount;
  }
  const calculateProgressBar = (milestones, amount) => {
    // funds completed
    let fundCompletedTotal = milestones.reduce((total, m) => {
      if (m.completed && m.direction === 'Fund') {
        return total + parseFloat(m.amount_value);
      }
      return total;
    }, 0);
    //releases completed
    let releaseCompletedTotal = milestones.reduce((total, m) => {
      if (m.completed && m.direction === 'Release') {
        return total + parseFloat(m.amount_value);
      }
      return total;
    }, 0);

    // fundCompletedTotal = 999.99; // testing
    // releaseCompletedTotal = 333.77; // testing
    setFundCompletedTotal(fundCompletedTotal);
    setReleaseCompletedTotal(releaseCompletedTotal);

    // release
    let width = Math.round((releaseCompletedTotal / amount) * 100);
    console.log('releaseWidth ', releaseCompletedTotal, amount, width, `${width}%`);
    setReleaseTextSide(width >= 50 ? 'left' : 'right');
    setReleaseWidths([`${width}%`, `${(100-width)}%`]);
    //fund
    width = Math.round((fundCompletedTotal / amount) * 100);
    console.log('fundWidth ', fundCompletedTotal, amount, width, `${width}%`);
    setFundTextSide(width >= 50 ? 'left' : 'right');
    setFundWidths([`${width}%`, `${(100 - width)}%`])

    console.log('fundCompletedTotal: ', fundCompletedTotal);
    console.log('releaseCompletedTotal: ', releaseCompletedTotal);
  }
  const tileMenuOptions = ['Cancel', 'Call', 'SMS', 'Email', 'Add to Contacts', 'View Profile'];
  const selectHomeowner = () => {
    if (addingContact) { return; }
    tileMenu(tileMenuOptions, homeowner, 'homeowner');
  }
  const selectContractor = () => {
    if (addingContact) { return; }
    // let options = [...tileMenuOptions];
    // options.push('See Profile');
    // tileMenu(options, contractor, 'contractor');
    tileMenu(tileMenuOptions, contractor, 'contractor');
  }
  const tileMenu = (options, homeownerContractor, type) => {
    console.log('select person: ', homeownerContractor);
    if(Platform.OS === 'ios'){
      ActionSheetIOS.showActionSheetWithOptions(
        {
          options: options,
          cancelButtonIndex: 0,
        },
        buttonIndex => {
          if (buttonIndex === 0) {
            // cancel action
          } else if (buttonIndex === 1) {
            call(stripPhoneNumber(homeownerContractor.phone_number));
          } else if (buttonIndex === 2) {
            sms(stripPhoneNumber(homeownerContractor.phone_number));
          } else if (buttonIndex === 3) {
            email(homeownerContractor.email_address);
          } else if (buttonIndex === 4) {
            addToContacts(homeownerContractor, type);
          } else if (buttonIndex === 5) {
            goToProfile(homeownerContractor, type);
          }
        }
      );
    }else{
      setAlertOptions({
        visible: true,
        title: null,
        message: 'Choose an action to perform',
        buttons: [
          {
            text: options[1],
            onPress: () => call(stripPhoneNumber(homeownerContractor.phone_number)),
          },
          {
            text: options[2],
            onPress: () => sms(stripPhoneNumber(homeownerContractor.phone_number)),
          },
          {
            text: options[3],
            onPress: () => email(homeownerContractor.email_address),
          },
          {
            text: options[4],
            onPress: () => addToContacts(homeownerContractor, type),
          },
          {
            text: options[5],
            onPress: () => goToProfile(homeownerContractor, type),
          },
          {
            text: 'Cancel',
            onPress: () => null,
          },
        ],
        dismissable: true,
      });
      // Alert.alert(
      //   "Choose Action",
      //   "Choose an action to perform",
      //   [
      //     {
      //       text: `${options[4]}/${options[5]}`,
      //       onPress: () => androidMenu2(options, homeownerContractor, type),
      //     },
      //     {
      //       text: `${options[1]}/${options[2]}/${options[3]}`,
      //       onPress: () => androidMenu1(options, homeownerContractor, type),
      //     },
      //   ]
      // )
    }
  }
  
  const call = (phoneNumber) => {
    console.log('Call homeowner: ', phoneNumber);
    // Linking.openURL(`tel:${phoneNumber}`);
    Linking.openURL(`tel:${phoneNumber}`);
  }
  const sms = async (phoneNumber) => {
    console.log('SMS homeowner: ', phoneNumber);
    const isAvailable = await SMS.isAvailableAsync();
    if (isAvailable) {
      // do your SMS stuff here
      const { result } = await SMS.sendSMSAsync(
        [phoneNumber],
      );
      if ((Platform.OS === 'ios' && result === 'sent') || (Platform.OS === 'android' && result === 'unknown')) {
        console.log('SMS sent successfully');
      }
    } else {
      setAlertOptions({ visible: true, title: 'Error', message: 'SMS is unavailable on your device.', });
    }
  }
  const email = async (emailAddress) => {
    console.log('Email homeowner: ', emailAddress);
    const isAvailable = await MailComposer.isAvailableAsync();
    if (isAvailable) {
      const { status } = await MailComposer.composeAsync({
        recipients: [emailAddress],
      });
      if (status === 'sent') {
        console.log('Email sent successfully');
      }
    } else {
      setAlertOptions({ visible: true, title: 'Error', message: 'Mail is unavailable on your device.', });
    }
  }

  const addToContacts = async (homeownerContractor, type) => {
    console.log('addToContacts: ', homeownerContractor);
    const { status } = await Contacts.requestPermissionsAsync();
    if(status === 'granted'){
      setAddingContact(true);
      let contact = {};
      if(type === 'homeowner'){
        contact[Contacts.Fields.ContactType] = Contacts.ContactTypes.Person;
        contact[Contacts.Fields.FirstName] = homeownerContractor.first_name;
        contact[Contacts.Fields.LastName] = homeownerContractor.last_name;
        contact[Contacts.Fields.Emails] = [{
          email: homeownerContractor.email_address,
          isPrimary: false,
          label: 'home',
        }];
        contact[Contacts.Fields.PhoneNumbers] = [{
          number: homeownerContractor.phone_number,
          isPrimary: false,
          digits: stripPhoneNumber(homeownerContractor.phone_number),
          label: 'home',
        }];
        if (homeownerContractor.address){
          contact[Contacts.Fields.Addresses] = [{
            street: homeownerContractor.address.street,
            city: homeownerContractor.address.city,
            country: homeownerContractor.address.country,
            region: homeownerContractor.address.region,
            postalCode: homeownerContractor.address.postalCode,
            label: 'Project Address',
          }];
        }
      }else if(type === 'contractor'){
        contact[Contacts.Fields.ContactType] = Contacts.ContactTypes.Company;
        contact[Contacts.Fields.Company] = homeownerContractor.company_name;
        contact[Contacts.Fields.FirstName] = homeownerContractor.first_name;
        contact[Contacts.Fields.LastName] = homeownerContractor.last_name;
        contact[Contacts.Fields.Emails] = [
          {
            email: homeownerContractor.email_address,
            isPrimary: false,
            label: 'Contractor Email Address'
          },
          {
            email: homeownerContractor.company_email_address,
            isPrimary: false,
            label: 'Company Email Address'
          },
        ];
        contact[Contacts.Fields.PhoneNumbers] = [
          {
            number: homeownerContractor.phone_number,
            isPrimary: false,
            digits: stripPhoneNumber(homeownerContractor.phone_number),
            label: 'Contractor Phone Number'
          },
          {
            number: homeownerContractor.company_phone_number,
            isPrimary: false,
            digits: stripPhoneNumber(homeownerContractor.company_phone_number),
            label: 'Company Phone Number'
          },
        ];
        contact[Contacts.Fields.Addresses] = [{
          street: homeownerContractor.address.street,
          city: homeownerContractor.address.city,
          country: homeownerContractor.address.country,
          region: homeownerContractor.address.region,
          postalCode: homeownerContractor.address.postalCode,
          label: 'Company Address',
        }];
        contact[Contacts.Fields.UrlAddresses] = [{
          url: homeownerContractor.website,
          label: 'Company Website',
        }]
      }

      const contactId = await Contacts.addContactAsync(contact);
      if(contactId){
        await Contacts.presentFormAsync(contactId, contact, { cancelButtonTitle: 'Save' });
      }
      setAddingContact(false);
    }else{
      setAlertOptions({ visible: true, title: 'Error', message: 'Access to contacts has been denied.', });
    }
  }
  const goToProfile = (homeownerContractor, type) => {
    console.log('select homeownerContractor: ', homeownerContractor, type);
    if(type === 'homeowner'){
      linkTo(`/customer/${homeownerContractor.id}`);
      // navigation.navigate('MoreDrawer', {
      //   screen: 'MainTabs',
      //   params: {
      //     screen: 'CustomersStack',
      //     params: {
      //       screen: 'Customer',
      //       params: {
      //         customerId: homeownerContractor.id
      //       }
      //     }
      //   }
      // });
    }else if(type === 'contractor'){
      linkTo(`/contractor/${homeownerContractor.company_id}`)
      // navigation.navigate('MoreDrawer', {
      //   screen: 'MainTabs',
      //   params: {
      //     screen: 'ContractorsStack',
      //     params: {
      //       screen: 'Contractor',
      //       params: {
      //         contractorId: homeownerContractor.id
      //       }
      //     }
      //   }
      // });
    }
  }

  const openAddress = () => {
    console.log('openAddress()', projectLocation);
    const company = Platform.OS === "ios" ? "apple" : "google";
    const address = encodeURIComponent(projectLocation);
    console.log('openAddress()', projectLocation, company, address);
    if(Platform.OS === 'web'){
      window.open(`https://maps.google.com/maps?daddr=${address}`, '_blank');
    }else{
      Linking.openURL(`http://maps.${company}.com/maps?daddr=${address}`);
    }
  }
  const goToMilestone = (milestone, proj) => {
    console.log('goToMilestone', milestone, proj, showJoin);
    if(showJoin) return;
    const project = proj !== undefined ? proj : existingProject;
    linkTo(`/project/${project.id}/milestone/${milestone.stage_id}`);
  }
  const pendingApprovalAlert = (field) => {
    console.log('pendingApprovalAlert(): ', field);
    setAlertOptions({ visible: true, title: 'Warning', message: `This ${field} change is pending approval from the ${isContractor ? 'homeowner' : 'contractor'}.`, });
  }

  const setWhoPaysOuter = (whoPays) => {
    if(!areAnyMilestonesCompleted(milestones)){
      setWhoPays(whoPays);
      // getFeeEstimates();
    }
  }
  const setAcceptCreditCardsOuter = (accept) => {
    if (!areAnyMilestonesCompleted(milestones)) {
      setAcceptCreditCards(accept);;
    }
  }

  const projectPhotoStyle1 = () => {
    // if(Platform.OS === 'web'){
    //   return {
    //     width: '100%',
    //     height: 576,
    //   }
    // }
    return {
      aspectRatio: projectPhoto.width / projectPhoto.height,
    }
  }
  const projectPhotoStyle2 = () => {
    // if (Platform.OS === 'web') {
    //   return {
    //     width: '100%',
    //     height: 576,
    //   }
    // }
    return {
      aspectRatio: Images.project.main.width / Images.project.main.height,
    }
  }

  const showTerms = () => {
    // linkTo(`/project/${project.id}/terms`);
    setShowTermsModal(true);
  }
  const confirmTerms = async () => {
    setShowTermsModal(false);
    console.log('save / join ... etc');
    if (termsAction === 'save') {
      // saveProject();
      let saveResult = await saveProject(false);
      if (saveResult.result) {
        // navigation.navigate('Projects');
        showAlert('success', 'Successfully Saved', () => linkTo('/projects'));
      }
    } else if (termsAction === 'join') {
      joinProject();
    } else if (termsAction === 'invite'){
      saveThenInvite();
    }
    return; // testing
  }
  const cancelTerms = () => {
    setShowTermsModal(false);
  }

  const onChangeDimensions = ({ window, screen }) => {
    console.log('onChangeDimensions');
    // setVideoWebStyle(videoStyle(window.width));
    setMainImageWebStyle(mainImageStyle(window.width));
  };

  const mainImageStyle = (windowWidth) => {
    const ratio = 1080 / 1440;
    if(Platform.OS === 'web'){
      const width = (windowWidth > 768) ? 768 : windowWidth;
      return {
        width: width,
        height: width * ratio,
      }
    }
  }

  const showWebToolTip = (type) => {
    console.log('showWebToolTip: ', type);
    let message = '';
    switch(type){
      case 'Project Documents':
        message = projectDocumentsToolTip.join(' ');
        break;
      case 'Inspirational Photos':
        message = inspirationalPhotosToolTip.join(' ');
        break;
    }

    setAlertOptions({
      visible: true,
      message: message,
    });
    // setLoading(true);
  }

  // draggable ordering functions
  const renderDraggable = ({ item, index, drag, isActive }) => {
    // const move2 = ()
    if(item.completed === undefined){
      return (
        <View style={styles.orderMilestoneContainer}>
          <TouchableOpacity
            activeOpacity={0.8}
            style={[styles.orderMilestoneCompleted, item.completed === undefined && styles.orderMilestoneNotCompleted, isActive && styles.orderMilestoneActive]}
            onLongPress={drag}
          >
            <Text style={[CS.smallText, (item.completed ? CS.lightBlueText : CS.blueText), isActive && { color: 'black' }]}>{item.title}</Text>
            {item.description ?
              <Text style={[CS.smallText, (item.completed ? CS.lightBlueText : CS.blueText), isActive && { color: 'black' }, { marginBottom: 5 }]}>{item.description}</Text>
              : null}
            <Text style={[CS.smallText, CS.boldText, (item.completed ? CS.lightBlueText : CS.blueText), isActive && { color: 'black' }]}>{item.completed ? (item.direction === 'Fund' ? 'Funded' : 'Released') : (item.direction)} {item.amount}</Text>
          </TouchableOpacity>
        </View>
      )
    }
    return (
      <View style={styles.orderMilestoneContainer}>
        <View
          style={[styles.orderMilestoneCompleted, item.completed === undefined && styles.orderMilestoneNotCompleted]}
        >
          <Text style={[CS.smallText, (item.completed ? CS.lightBlueText : CS.blueText)]}>{item.title}</Text>
          {item.description ?
            <Text style={[CS.smallText, (item.completed ? CS.lightBlueText : CS.blueText), { marginBottom: 5 }]}>{item.description}</Text>
            : null}
          <Text style={[CS.smallText, CS.boldText, (item.completed ? CS.lightBlueText : CS.blueText)]}>{item.completed ? (item.direction === 'Fund' ? 'Funded' : 'Released') : (item.direction)} {item.amount}</Text>
          <FontAwesome name="lock" size={20} color={Colors.lightBlue2} style={styles.lockIcon} />
        </View>
      </View>
    )
  }
  const renderPlaceholder = ({ item, index, drag, isActive }) => {
    // const move2 = ()
    return (
      <View style={styles.orderMilestoneContainer}>
        <View
          style={[styles.orderMilestoneCompleted, item.completed === undefined && styles.orderMilestoneNotCompleted, { opacity: 0.4 }]}
        >
          <Text style={[CS.smallText, (item.completed ? CS.lightBlueText : CS.blueText)]}>{item.title}</Text>
          {item.description ?
            <Text style={[CS.smallText, (item.completed ? CS.lightBlueText : CS.blueText), { marginBottom: 5 }]}>{item.description}</Text>
            : null}
          <Text style={[CS.smallText, CS.boldText, (item.completed ? CS.lightBlueText : CS.blueText)]}>{item.completed ? (item.direction === 'Fund' ? 'Funded' : 'Released') : (item.direction)} {item.amount}</Text>
        </View>
      </View>
    )
  }
  const showOrdering = () => {
    console.log('showOrdering', ordering);
    if (isNew && defaultAmountType === 'percent') {
      milestones.forEach(m => m.amount_dollar_value = formatAmount(projectTotal) * (m.amount_value / 100))
    } else {
      milestones.forEach(m => m.amount_dollar_value = m.amount_value)
    }
    setOrdering(true);
  }
  const hideOrdering = () => {
    console.log('hideOrdering', ordering);
    setOrdering(false);
  }
  const dragEnd = ({ data, from, to }) => {
    console.log('onDragEnd: ', data, from, to);
    if(canItemBeDropped(data, from, to)){
      console.log('can be dropped..proceed')
      // setMilestones(data);
      data.forEach((m, i) => {
        m.sequence = i + 1;
      });

      dispatchMilestones({
        type: 'orderMilestones',
        payload: data,
      });
    }else{
      console.log('cant be dropped..revert');
    }
  }
  const canItemBeDropped = (data, from, to) => {
    console.log('canItemBeDropped: ', data, from, to);
    // check amounts/balance
    let balance = 0;
    let result = true;
    for(let i=0;i<data.length;i++){
      console.log('data[i]: ', data[i].direction, data[i].amount_dollar_value);
      if(data[i].direction === 'Fund'){
        balance += parseFloat(data[i].amount_dollar_value);
      }else{
        balance -= parseFloat(data[i].amount_dollar_value);
      }
      console.log('balance: ', balance);
      if(balance < 0){
        console.log('balance less than 0..false');
        result = false
        break;
      }
    }
    if(!result){ return false; }

    // check completed
    console.log('check completed: ');
    if(to !== (data.length - 1)){
      if(data[to + 1].completed === 'Yes'){
        result = false;
      }
    }

    return result;
  }

  if(ordering){
    return (
      <SafeAreaView style={CS.safe}>
        <View style={styles.orderingView}>
          <Text style={[CS.smallTitle, CS.lightText]}>Re-Order Milestones</Text>
          <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>Long Press and hold the milestone until it turns yellow, then drag and release it to change the order. You cannot change the order of completed milsetones.</Text>
          <DraggableFlatList
            data={milestones}
            renderItem={renderDraggable}
            renderPlaceholder={renderPlaceholder}
            keyExtractor={item => item.sequence.toString()}
            onDragEnd={dragEnd}
            onDragBegin={() => { console.log('onDragBegin()'); }}
            containerStyle={{ marginBottom: 10, flex: 1 }}
          />
          <Button text='Done' onPress={() => hideOrdering} />
        </View>
      </SafeAreaView>
    )
  }else{
    return (
      <View style={{ flex: 1 }}>
        <BackgroundGradient />
        <Loader animating={loading} />
        <Alert options={alertOptions} setOptions={setAlertOptions} />
        <TermsModal
          show={showTermsModal}
          // show={true}
          setShow={setShowTermsModal}
          signatureText={signatureText}
          setSignatureText={setSignatureText}
          signature={signature}
          setSignature={setSignature}
          confirmTerms={confirmTerms}
          cancelTerms={cancelTerms}
        />
        {/* keyboardDismissMode='on-drag' */}
        {/* <KeyboardAwareScrollView keyboardShouldPersistTaps='handled' style={styles.container} contentContainerStyle={styles.innerContainer} ref={scrollRef}> */}
        <KeyboardAwareScrollView keyboardShouldPersistTaps='handled' keyboardDismissMode='on-drag' enableResetScrollToCoords={false} style={styles.container} contentContainerStyle={styles.innerContainer} ref={scrollRef} extraHeight={insets.top}>
          <View>
          {/* main image container */}
          <View style={styles.logoContainer}>
            {projectPhoto && 
              <Image source={{ uri: projectPhoto.uri }} style={[CS.responsiveImage, styles.projectImage, projectPhotoStyle1(), mainImageWebStyle]} />
            }
            {(!projectPhoto && !mainImageUrl) &&
              <Image source={(stage === 'Completed') ? defaultProjectImageCompleted : defaultProjectImage} style={[CS.responsiveImage, projectPhotoStyle2(), mainImageWebStyle]} />
            }
            {mainImageUrl &&
              <CachedImage source={{ uri: mainImageUrl }} style={[CS.responsiveImage, projectPhotoStyle2(), mainImageWebStyle]} />
            }
            <LinearGradient colors={[Colors.darkGrey, 'transparent', Colors.darkGrey]} style={styles.gradient} />
            {editing && 
            <Pressable activeOpacity={0.6} onPress={promptProjectPhoto} style={({ pressed }) => [styles.projectPhotoButtonContainer, { opacity: pressed ? 0.5 : 1.0 }]} hitSlop={10}>
              <FontAwesome name="image" size={32} color="white" />
            </Pressable>
            }
            {!editing && 
            // title/location/amount overlay
            <View style={styles.mainImageInfoOverlay}>
              <Text style={[CS.largeText, CS.boldText, CS.yellowText, CS.flexWrap]}>{projectTitle}</Text>
              <View style={[CS.flex, CS.rowContainer]}>
                {(!isNew && existingProject && !existingProject.address.accepted) &&
                  <TouchableOpacity activeOpacity={0.6} onPress={() => pendingApprovalAlert('location')}>
                    <AntDesign name="exclamationcircle" size={16} color={Colors.yellow} style={{ marginRight: 2 }} />
                  </TouchableOpacity>
                }
                <View style={[CS.flex, { marginRight: 5 }]}>
                  <TouchableOpacity activeOpacity={0.6} onPress={openAddress} style={[CS.rowContainer, { marginTop: 5 }]}>
                    <Entypo name="location-pin" size={16} color={Colors.lightText} />
                    <Text style={[CS.miniText, CS.lightText, CS.flexWrap]}>{addressPreview}</Text>
                  </TouchableOpacity>
                  {isContractor && existingProject && existingProject.homeowner_id && existingProject.homeowner && 
                    <TouchableOpacity activeOpacity={0.6} onPress={() => goToProfile(existingProject.homeowner, 'homeowner')} style={[CS.rowContainer, { marginTop: 5 }]}>
                      <FontAwesome name="user" size={16} color={Colors.lightText} style={{ marginRight: 5 }} />
                      <Text style={[CS.miniText, CS.lightText, CS.flexWrap]}>{`${existingProject.homeowner.first_name} ${existingProject.homeowner.last_name}`}</Text>
                    </TouchableOpacity>
                  }
                </View>
                <Text style={[CS.largeText, CS.boldText, CS.lightText]}>{formatCurrency(projectAmount)}</Text>
              </View>
            </View>
            }
            <ProjectLockOverlay stage={stage} />
          </View>
          {/* navigate/edit buttons container */}
          <View style={styles.buttonsOverlay}>
            <TouchableOpacity onPress={goBack}>
              <FontAwesome5 name="arrow-left" size={24} color="white" />
            </TouchableOpacity>
            {((stage !== 'Completed' && stage !== 'In-Dispute' && stage !== 'Court/Arbitration') && !showJoin) &&
              <TouchableOpacity onPress={toggleEditProject} style={styles.editButton}>
                {!editing &&
                <Entypo name="edit" size={24} color="white" />
                }
                {(editing && !isNew) &&
                <MaterialCommunityIcons name="cancel" size={24} color="white" />
                }
              </TouchableOpacity>
            }
          </View>
            {((stage !== 'Completed' && stage !== 'In-Dispute' && stage !== 'Court/Arbitration') && !isNew && !loading && !showJoin) &&
            <View style={[styles.marginContainer, { marginBottom: 10 }]}>
              <Button text={editing ? 'Cancel Edit / Change Order' : 'Edit Project / Change Order'} onPress={() => toggleEditProject} />
            </View>
          }

          {(user.isContractor && isNew) &&
            // buttons for contractor to toggle whether they are contractor or homeowner
            <View style={[styles.marginContainer, { marginTop: 10 }]}>
              <Text style={[CS.smallTitle, CS.lightText, { marginVertical: 0 }]}>Select your role for this project</Text>
              <View style={styles.tabButtonContainer}>
                <ToggleButtons setValue={setIsContractor} value={isContractor} button1Text={"I'm the Contractor"} button2Text={"I'm the Homeowner"} />
              </View>
            </View>
          }

          {editing &&
          <>
            <View style={[styles.marginContainer, { marginTop: 10 }]}>
              <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Project Title</Text>
              <TextInputContainer
                placeholder='What would you like to call this project?'
                onChangeText={(t) => onChangeProjectTitle(t)}
                inputRef={textInputs.title}
                isInvalid={isInvalid.title}
                autoCapitalize='words'
                onSubmitEditing={() => textInputs.location.current.focus()}
                returnKeyType='next'
                value={projectTitle}
                editable={editing}
              />
            </View>
            <View style={styles.marginContainer}>
              <View style={[CS.rowContainer, styles.inputLabel]}>
                <Text style={[CS.smallText, CS.lightBlueText]}>Location of Project</Text>
                  <ToolTipWrapper
                    text={addressToolTip}
                  />
                {(!isNew && existingProject && !existingProject.address.accepted) &&
                  <TouchableOpacity activeOpacity={0.6} onPress={() => pendingApprovalAlert('location')}>
                    <AntDesign name="exclamationcircle" size={24} color={Colors.yellow} style={{ marginLeft: 5 }} />
                  </TouchableOpacity>
                }
              </View>
            </View>
            <AddressPicker
              placeholder={Platform.OS === 'web' ? '10-1000 Main St. Toronto, ON' : 'Where is the project located?'}
              innerPlaceholder='10-1000 Main St. Toronto, ON'
              value={projectLocation}
              setAddress={setProjectLocation}
              setStreetId={setProjectStreetId}
              setStreetNumber={setProjectStreetNumber}
              setAddressUnit={setProjectAddressUnit}
              offsetTop={Constants.statusBarHeight}
              outerInputContainerStyle={styles.marginContainer}
              inputRef={textInputs.location}
              setIsInvalid={setIsInvalidLocation}
              editable={editing}
            />
          </>
          }

          <View style={styles.marginContainer}>
            {editing &&
            <>
              {/* <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Scope of Work{!existingProject.description.accepted ? <Text style={CS.yellowText}> - Pending Approval</Text> : null}</Text> */}
              <View style={[CS.rowContainer, styles.inputLabel]}>
                <Text style={[CS.smallText, CS.lightBlueText]}>Scope of Work</Text>
                {(Platform.OS !== 'web' || isMobile) && editing ?
                  <ToolTipWrapper
                    text={fullScopePlaceholder}
                  />
                : null}
                {(!isNew && existingProject && existingProject.description && !existingProject.description.accepted) &&
                  <TouchableOpacity activeOpacity={0.6} onPress={() => pendingApprovalAlert('description')}>
                    <AntDesign name="exclamationcircle" size={24} color={Colors.yellow} style={{ marginLeft: 5 }} />
                  </TouchableOpacity>
                }
              </View>
              {/* <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Scope of Work</Text> */}
              <TextInputContainer
                placeholder={(Platform.OS === 'web' && !isMobile) ? fullScopePlaceholder.join(' ') : 'Provide a summary of what your project includes.'}
                onChangeText={(t) => onChangeProjectDescription(t)}
                inputRef={textInputs.projectDescription}
                isInvalid={isInvalid.projectDescription}
                returnKeyLabel='return'
                value={projectDescription}
                inputStyle={styles.description}
                multiline={true}
                numberOfLines={6}
                autoCorrect={false}
                spellCheck={true}
                editable={editing}
              />
            </>
            }
            {(!editing && projectDescription && projectDescription.length > 0) ?
              <>
                <View style={[CS.rowContainer, styles.inputLabel]}>
                  <Text style={[CS.smallTitle, CS.lightText, { marginVertical: 0 }]}>Scope of Work</Text>
                  {(!isNew && !existingProject.description.accepted) &&
                    <TouchableOpacity activeOpacity={0.6} onPress={() => pendingApprovalAlert('description')}>
                      <AntDesign name="exclamationcircle" size={24} color={Colors.yellow} style={{ marginLeft: 5 }} />
                    </TouchableOpacity>
                  }
                </View>
                {/* <Text style={[CS.smallTitle, CS.lightText, styles.inputLabel, { marginVertical: 0 }]}>Scope of Work</Text> */}
                <Text style={[CS.miniText, CS.lightBlueText, { marginBottom: 20 }]}>{projectDescription}</Text>
              </>
              : []
            }
            
          </View>
          {/* photos */}
          {/* inspiration */}
          {(editing || (!editing && inspirationPhotos.length > 0)) &&
            <View style={[styles.marginContainer, styles.photosContainer]}>
              <View style={styles.photoTitleContainer}>
                <Text style={[CS.smallTitle, CS.lightText, { marginVertical: 0 }]}>Inspirational Photos</Text>
                {editing &&
                  <ToolTipWrapper
                    text={inspirationalPhotosToolTip}
                  />
                }
              </View>
              <Text style={[CS.miniText, CS.lightBlueText, { marginTop: -10, marginBottom: 10, }]}>Photos are non-legally binding</Text>
              <PhotosDocumentsAddPreviewGrid
                items={inspirationPhotos}
                setItems={setInspirationPhotos}
                // setRemoveIds={setInspirationDelete}
                showAdd={editing}
                captions={true}
                saveCaption={true}
                captionUrl={`agreements/${projectId}/uploads/:id`}
                upload={true}
                uploadUrl={`agreements/${projectId}/uploads`}
                uploadDeleteUrl={`agreements/${projectId}/uploads/:id`}
                uploadAdditionalData={{type: 'inspiration'}}
                scrollable={(!editing)}
                setDisabled={setButtonDisabled}
              />
            </View>
          }
          {/* progress */}
          {((editing && stage === 'In-Progress') || (!editing && progressPhotos.length > 0)) &&
            <View style={[styles.marginContainer, styles.photosContainer]}>
              <View style={styles.photoTitleContainer}>
                <Text style={[CS.smallTitle, CS.lightText, { marginVertical: 0 }]}>Progress Photos</Text>
              </View>
              <PhotosDocumentsAddPreviewGrid
                items={progressPhotos}
                setItems={setProgressPhotos}
                showAdd={editing}
                captions={true}
                saveCaption={true}
                captionUrl={`agreements/${projectId}/uploads/:id`}
                upload={true}
                uploadUrl={`agreements/${projectId}/uploads`}
                uploadAdditionalData={{ type: 'progress' }}
                delete={false}
                scrollable={(!editing)}
                setDisabled={setButtonDisabled}
              />
            </View>
          }
          {/* other */}
          {(editing || (!editing && otherPhotos.length > 0)) &&
            <View style={[styles.marginContainer, styles.photosContainer]}>
              <View style={styles.photoTitleContainer}>
                <Text style={[CS.smallTitle, CS.lightText, { marginVertical: 0 }]}>Project Documents</Text>
                {editing &&
                  <ToolTipWrapper
                    text={projectDocumentsToolTip}
                  />
                }
              </View>
              <PhotosDocumentsAddPreviewGrid
                items={otherPhotos}
                setItems={setOtherPhotos}
                // setRemoveIds={setOtherDelete}
                showAdd={editing}
                captions={true}
                saveCaption={true}
                captionUrl={`agreements/${projectId}/uploads/:id`}
                upload={true}
                uploadUrl={`agreements/${projectId}/uploads`}
                uploadDeleteUrl={`agreements/${projectId}/uploads/:id`}
                uploadAdditionalData={{ type: 'image' }}
                documents={true}
                setDisabled={setButtonDisabled}
                pendingApprovalAlert={pendingApprovalAlert}
                requiresApproval={(stage === 'In-Progess') ? true : false}
              />
            </View>
          }
          {/* progress bar */}
          {/* <Text style={[CS.smallText, CS.lightText]}>Total: {formatCurrency(projectAmount)}</Text>
          <Text style={[CS.smallText, CS.lightText]}>funded: {formatCurrency(fundCompletedTotal)}</Text>
          <Text style={[CS.smallText, CS.lightText]}>released: {formatCurrency(releaseCompletedTotal)}</Text>
          <Text style={[CS.smallText, CS.lightText]}>fundTextSide: {fundTextSide}</Text>
          <Text style={[CS.smallText, CS.lightText]}>fundWidths: {fundWidths}</Text>
          <Text style={[CS.smallText, CS.lightText]}>releaseTextSide: {releaseTextSide}</Text>
          <Text style={[CS.smallText, CS.lightText]}>releaseWidths: {releaseWidths}</Text> */}
          {(!editing && projectAmount > 0) &&
            <View style={{ marginBottom: 30 }}>
              <View style={[styles.marginContainer, CS.rowContainer]}>
                <View style={[{ width: fundWidths[0], borderWidth: 0, borderColor: Colors.green, borderRightWidth: 2 }]}>
                  <Text style={[CS.smallText, CS.greenText, CS.boldText, CS.rightText, { paddingRight: 10, paddingBottom: 7 }]}>{(fundTextSide === 'left') ? `Funded ${formatCurrency(fundCompletedTotal)}` : ' '}</Text>
                </View>
                <View style={[{ width: fundWidths[1], borderWidth: 0 }]}>
                  <Text style={[CS.smallText, CS.greenText, CS.boldText, CS.leftText, { paddingLeft: 10, paddingBottom: 7 }]}>{(fundTextSide === 'right' && fundCompletedTotal !== 0) ? `Funded ${formatCurrency(fundCompletedTotal)}` : (fundCompletedTotal === 0 ? 'Funded $0.00' : '')}</Text>
                </View>
              </View>
              {/* OLD */}
              {/* <View style={[styles.marginContainer, { height: 12 }]}>
                <View style={[styles.progressBar, styles.totalBar]}></View>
                <View style={[{ width: fundWidths[0] }, styles.progressBar, styles.fundBar]}></View>
                <View style={[{ width: releaseWidths[0] }, styles.progressBar, styles.releaseBar]}></View>
              </View> */}
              {/* NEW */}
              <View style={[styles.marginContainer, { height: 12 }]}>
                <View style={[styles.progressBar, styles.totalBar]}></View>
                <View style={[{ width: fundWidths[0] }, styles.progressBar, styles.fundBar]}></View>
              </View>
              <View style={[styles.marginContainer, { height: 12, marginTop:5 }]}>
                <View style={[styles.progressBar, styles.totalBar]}></View>
                <View style={[{ width: releaseWidths[0] }, styles.progressBar, styles.releaseBar]}></View>
              </View>
              <View style={[styles.marginContainer, CS.rowContainer]}>
                <View style={[{ width: releaseWidths[0], borderWidth: 0, borderColor: Colors.yellow, borderRightWidth: 2 }]}>
                  <Text style={[CS.smallText, CS.yellowText, CS.boldText, CS.rightText, { paddingRight: 10, paddingTop: 7 }]}>{(releaseTextSide === 'left') ? `Released ${formatCurrency(releaseCompletedTotal)}` : ' '}</Text>
                </View>
                <View style={[{ width: releaseWidths[1], borderWidth: 0 }]}>
                  <Text style={[CS.smallText, CS.yellowText, CS.boldText, CS.leftText, { paddingLeft: 10, paddingTop: 7 }]}>{(releaseTextSide === 'right' && releaseCompletedTotal !== 0) ? `Released ${formatCurrency(releaseCompletedTotal)}` : (releaseCompletedTotal === 0 ? 'Released $0.00' : '')}</Text>
                </View>
              </View>
            </View>
          }
          
          {/* <Button text='Order Milestones' onPress={() => showOrdering} /> */}
          {/* total */}
          {isNew && 
            <View style={[styles.marginContainer, { marginTop: 10 }]}>
              <Text style={[CS.smallTitle, CS.lightText, { marginVertical: 0 }]}>Total Cost of Project</Text>
              <Text style={[CS.smallText, CS.lightBlueText, { marginVertical: 10 }]}>Includes all fees and taxes</Text>
              <TextInputContainer
                // placeholder='Cost including all fees and taxes'
                placeholder=''
                onChangeText={(t) => onChangeProjectTotal(t) }
                inputRef={textInputs.total}
                isInvalid={isInvalid.total}
                keyboardType='numeric'
                // onSubmitEditing={() => textInputs.location.current.focus()}
                // returnKeyType='next'
                onBlur={() => onBlurTotal(projectTotal)}
                value={projectTotal}
                editable={editing}
                inputStyle={{ fontSize: 58 }}
                returnKeyType='done'
              />
            </View>
          }
          {/* milestones */}

          <View style={[styles.marginContainer, { marginTop: 0 }]}>
            <Text style={[CS.smallTitle, CS.lightText, { marginTop: 0, marginBottom: 10 }]}>Milestones</Text>
            {editing &&
              <>
                <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>{isNew ? 'Divide your project up into stages where money is released to the contractor.' : 'Divide your project into stages where money is funded by the homeowner and released to the contractor.'}</Text>
                <View>
                  {milestoneBlurbListItems.map((v, index) => { return (<ULItem text={v} key={index} textColor='lightBlue' />); })}
                </View>
                <PlayVideoButton
                  text='How to set up your milestones'
                  length='2:09'
                  source='https://renovationtrust.s3.ca-central-1.amazonaws.com/production/resources/creatingMilestones.mp4'
                  youtube='K4ING_ZU1Nw'
                  outerContainerStyle={styles.playVideoContainer}
                />
              </>
            }
            {/* legend */}
            {!editing &&
              <View style={[CS.rowContainer, { marginBottom: 20 }]}>
                <View style={[CS.rowContainer, { marginRight: 20 }]}>
                  <FontAwesome name="square" size={24} color={Colors.green} style={{ marginRight: 5 }} />
                  <Text style={[CS.smallText, CS.lightBlueText]}>Completed</Text>
                </View>
                <View style={[CS.rowContainer, { marginRight: 20 }]}>
                  <FontAwesome name="square" size={24} color={Colors.yellow} style={{ marginRight: 5 }} />
                  <Text style={[CS.smallText, CS.lightBlueText]}>Current</Text>
                </View>
                <View style={[CS.rowContainer]}>
                  <FontAwesome name="square" size={24} color={Colors.lightBlue2} style={{ marginRight: 5 }} />
                  <Text style={[CS.smallText, CS.lightBlueText]}>Pending</Text>
                </View>
              </View>
            }
            {milestones.map((m, index) => {
              return (
                <ProjectMilestone
                  key={m.uuid}
                  milestone={m}
                  dispatch={dispatchMilestones}
                  showOrdering={showOrdering}
                  editing={editing}
                  existing={existingProject}
                  onFocusAmount={onFocusAmount}
                  onBlurAmount={onBlurAmount}
                  setDefaultAmountType={setDefaultAmountType}
                  showDirection={!isNew && !m.completed && editing}
                  last={index === milestones.length - 1}
                  goToMilestone={goToMilestone}
                  isContractor={isContractor}
                  isNew={isNew}
                  projectStage={stage}
                />
              );
            })}
          </View>
          {editing &&
            // add milestone
            <TouchableOpacity style={[styles.marginContainer, styles.newMilestoneContainer]} activeOpacity='0.6' onPress={() => addNewMiletsone()}>
              {/* <TouchableOpacity activeOpacity='0.6' onPress={() => addNewMiletsone()}> */}
              <Ionicons name="ios-add-circle" size={48} color={Colors.yellow} />
              {/* </TouchableOpacity> */}
              <Text style={[CS.smallTitle, CS.lightText, styles.newMilestoneText]}>Add New Milestone</Text>
            </TouchableOpacity>
          }
          
          {/* {!editing &&
            <View style={[styles.marginContainer, styles.newMilestoneContainer]}>
              <Ionicons name="ios-checkmark-circle" size={48} color={Colors.yellow} />
            </View>
          } */}
          {/* who pays */}
          {(isContractor && editing && !showJoin) &&
          <View style={[styles.marginContainer, { marginTop: 0 }]}>
            {(fundedTotal === 0) &&
              <>
                <Text style={[CS.smallTitle, CS.lightText, { marginVertical: 0 }]}>Who pays the Protection Fee?</Text>
                <View style={[CS.rowContainer, styles.tabButtonContainer]}>
                  <TouchableOpacity activeOpacity={0.6} onPress={() => setWhoPaysOuter('Contractor')} style={[CS.tabButton, CS.tabButtonLeft, (whoPays === 'Contractor' && CS.tabButtonActive)]}>
                    <Text style={[CS.smallText, CS.boldText, CS.lightText, (whoPays === 'Contractor' && CS.darkText)]}>Contractor</Text>
                    {feeEstimate &&
                      <Text style={[CS.smallText, CS.lightText, (whoPays === 'Contractor' && CS.darkText), { marginTop: 3 }]}>{formatCurrency(feeEstimate.contractor)}</Text>
                    }
                  </TouchableOpacity>
                  <TouchableOpacity activeOpacity={0.6} onPress={() => setWhoPaysOuter('50_50')} style={[CS.tabButton, CS.tabButtonCenter, (whoPays === '50_50' && CS.tabButtonActive), { alignSelf: 'stretch', justifyContent: 'center', flex: 1 }]}>
                    <Text style={[CS.smallText, CS.boldText, CS.lightText, (whoPays === '50_50' && CS.darkText)]}>50/50</Text>
                    {/* {feeEstimate &&
                  // <Text style={[CS.smallText, CS.lightText, (whoPays === '50_50' && CS.darkText), { marginTop: 3 }]}>{formatCurrency(feeEstimate['50_50'])}</Text>
                  // <Text style={[CS.smallText, CS.lightText, (whoPays === '50_50' && CS.darkText), { marginTop: 3 }]}> </Text>
                } */}
                  </TouchableOpacity>
                  <TouchableOpacity activeOpacity={0.6} onPress={() => setWhoPaysOuter('Homeowner')} style={[CS.tabButton, CS.tabButtonRight, (whoPays === 'Homeowner' && CS.tabButtonActive)]}>
                    <Text style={[CS.smallText, CS.boldText, CS.lightText, (whoPays === 'Homeowner' && CS.darkText)]}>Homeowner</Text>
                    {feeEstimate &&
                      <Text style={[CS.smallText, CS.lightText, (whoPays === 'Homeowner' && CS.darkText), { marginTop: 3 }]}>{formatCurrency(feeEstimate.homeowner)}</Text>
                    }
                  </TouchableOpacity>
                </View>
              </>
            }
            <TouchableOpacity activeOpacity={0.6} onPress={() => setAcceptCreditCardsOuter(!acceptCreditCards)}>
              <View style={[CS.rowContainer, styles.acceptCreditCardsContainer]}>
                <Ionicons name={acceptCreditCards ? 'ios-checkbox' : 'ios-square-outline'} size={48} color={Colors.lightBlue} />
                <View style={{ marginLeft: 10, flex: 1 }}>
                  <Text style={[CS.smallText, CS.boldText, CS.lightText, { marginVertical: 0 }]}>Accept credit and debit cards for amounts under $3,000?</Text>
                  <Text style={[CS.smallText, CS.lightBlueText, { marginTop: 5 }]}>3.05% + $0.30 / transaction</Text>
                </View>
              </View>
            </TouchableOpacity>
          </View>
          }
          {/* <Text style={[CS.smallText, CS.lightText]}>{isHomeowner ? 'is homeowner' : 'is contractor'}</Text>
          <Text style={[CS.smallText, CS.lightText]}>{showHomeownerTile ? 'showHomeownerTile' : '!showHomeownerTile'}</Text>
          <Text style={[CS.smallText, CS.lightText]}>{showContractorTile ? 'showContractorTile' : '!showContractorTile'}</Text> */}
          {showHomeownerTile && 
          // homeowner tile
          <TouchableOpacity activeOpacity={0.6} style={[styles.contractorTile, CS.rowContainer]} onPress={selectHomeowner}>
            <View style={styles.contractorTileInner}>
              <View style={styles.avatarContainer}>
                <UserAvatar size='medium' userId={homeowner.id} avatar={homeowner.avatar} verified={homeowner.verified} />
              </View>
              <View style={CS.flex}>
                <Text style={[CS.mediumText, CS.boldText, CS.lightText]}>{homeowner.first_name + ' ' + homeowner.last_name}</Text>
                <Text style={[CS.smallText, CS.lightBlueText, { marginTop: 5, marginBottom: 3 }]}>{homeowner.phone_number}</Text>
                <Text style={[CS.smallText, CS.lightBlueText]}>{homeowner.email_address}</Text>
              </View>
            </View>
            <LoaderSmall loading={addingContact} style={{ borderRadius: 10 }} />
          </TouchableOpacity>
          }
          {(showContractorTile && !joinButtonDisabled) &&
          // contractor tile
          <TouchableOpacity activeOpacity={0.6} style={[styles.contractorTile, CS.rowContainer]} onPress={selectContractor}>
            <View style={styles.contractorTileInner}>
              <View style={styles.avatarContainer}>
                <UserAvatar size='medium' userId={contractor.id} avatar={contractor.avatar} verified={contractor.verified} />
              </View>
              <View style={CS.flex}>
                <Text style={[CS.mediumText, CS.boldText, CS.lightText]}>{contractor.company_name}</Text>
                <Text style={[CS.smallText, CS.lightBlueText, { marginTop: 3 }]}>{contractor.first_name + ' ' + contractor.last_name}</Text>
                <Text style={[CS.smallText, CS.lightBlueText, { marginVertical: 3 }]}>{contractor.phone_number}</Text>
                <Text style={[CS.smallText, CS.lightBlueText]}>{contractor.email_address}</Text>
              </View>
            </View>
            <LoaderSmall loading={addingContact} style={{ borderRadius: 10 }}/>
          </TouchableOpacity>
          }
          {showInvite && 
            // invite contractor/homeowner
            <TouchableOpacity activeOpacity={0.6} style={styles.inviteTile} onPress={inviteContractor}>
              <FontAwesome name="user-circle-o" size={72} color={Colors.lightGrey} style={styles.contractorAvatar} />
            {/* <Text style={[CS.mediumText, CS.lightText]}>{fundTotal === 0 ? `Invite ${isContractor ? 'Customers' : 'Contractors'} to Quote` : `Invite your ${isContractor ? 'Customer' : 'Contractor'}`}</Text> */}
            <Text style={[CS.mediumText, CS.lightText]}>{projectAmount === 0 ? `Invite ${isContractor ? 'Customers' : 'Contractors'} to Quote` : `Invite your ${isContractor ? 'Customer' : 'Contractor'}`}</Text>
            </TouchableOpacity>
          }
          {invitePending && 
            // show that invitation has been sent and is pending approval
            <TouchableOpacity activeOpacity={0.6} style={styles.inviteTile} onPress={inviteContractor}>
              <FontAwesome name="user-circle-o" size={72} color={Colors.lightGrey} style={styles.contractorAvatar} />
              <View>
                <Text style={[CS.mediumText, CS.lightText]}>Invite Sent</Text>
                <Text style={[CS.mediumText, CS.lightBlueText]}>Try Again</Text>
              </View>
            </TouchableOpacity>
          }
          {/* join */}
          {showJoin &&
            <>
              <View style={[styles.marginContainer, styles.feeTile]}>
                <Text style={[CS.smallTitle, CS.lightText, { marginTop: 0, marginBottom: 10 }]}>Protection Fees</Text>
                <Text style={[CS.smallText, CS.lightText, { marginBottom: 5 }]}><Text style={CS.lightBlueText}>Project Cost:</Text> {formatCurrency(fundTotal)}</Text>
                <Text style={[CS.smallText, CS.lightText, { marginBottom: 5 }]}><Text style={CS.lightBlueText}>{isContractor ? 'Homeowner' : 'Contractor'} Fee:</Text> {formatCurrency(isContractor ? feeEstimate.homeowner : feeEstimate.contractor)}</Text>
                <Text style={[CS.smallText, CS.lightText, { marginBottom: 15 }]}><Text style={CS.lightBlueText}>Your Fee:</Text> {formatCurrency(isContractor ? feeEstimate.contractor : feeEstimate.homeowner)}</Text>
              

              <View style={{ marginBottom: 10 }}>
                <Button text='Agree to this project' onPress={() => beforeJoinProject} disabled={joinButtonDisabled} />
                {joinButtonDisabled &&
                  <Text style={[CS.miniText, CS.greyText, CS.centerText, { marginTop: 5 }]}>*Only a contractor can join this project</Text>
                }
              </View>
              <View style={{ marginBottom: 10 }}>
                <Button text='Decline this project' onPress={() => promptDeclineProject} color='red' disabled={joinButtonDisabled} />
              </View>
              {/* <View style={{ marginBottom: 20 }}> */}
                <Button text='Changes are required' onPress={() => promptChangeProject} color='blue' disabled={joinButtonDisabled} />
              {/* </View> */}
              <DeclineChangeModal
                modalVisible={declineChangeModalVisible}
                setModalVisible={setDeclineChangeModalVisible}
                reason={declineChangeReason}
                setReason={setDeclineChangeReason}
                confirm={declineChangeProject}
                action={declineChangeAction}
              />
            </View>
            </>
          }
          {/* save project */}
          {(showSave && editing) &&
            <View style={[styles.marginContainer, { marginBottom: 20 }]}>
              <Button text={saveButtonText} onPress={() => saveProjectWrapper} disabled={buttonDisabled}/>
            </View>
          }
          {(showDelete && editing) &&
            // delete project
            <View style={[styles.marginContainer, { marginBottom: 20 }]}>
              <Button text='Delete Project' onPress={() => promptDeleteProject} color='red' disabled={buttonDisabled} />
            </View>
          }
          
          {/* test terms screen */}
          {/* <View style={[styles.marginContainer, { marginBottom: 20 }]}>
              <Button text='Test Terms' onPress={() => showTerms} color='red' disabled={buttonDisabled} />
          </View> */}

          {/* <Button text='Test - Go to fund milestone' onPress={() => goToFirstFundMilestone} /> */}
          {/* history */}
          {(!isNew && editing) &&
            <View style={styles.marginContainer}>
              <ProjectHistory history={history} />
            </View>
          }
          </View>
        </KeyboardAwareScrollView>
      </View>
    )
  }
}

const styles = StyleSheet.create({
  safe: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
  container: {

  },
  orderingView: {
    flex: 1,
    paddingHorizontal: 10,
    paddingBottom: 10,
    maxWidth: Platform.OS === 'web' ? 768 : '100%',
    alignSelf: 'center',
  },
  innerContainer: {
    width: '100%',
    flexGrow: 1,
    maxWidth: Platform.OS === 'web' ? 768 : '100%',
    alignSelf: 'center',
  },
  blurTest: {
    position: 'absolute',
    top: 10,
    left: 10,
    width: '100%',
    height: '100%',
    padding: 10,
    borderRadius: 10,
    zIndex: 4,
  },
  // scrollView: {
  //   backgroundColor: Colors.blue,
  //   flex: 1,
  // },
  container: {
    flex: 1,
    width: '100%',
    height: '100%',
    // position: 'relative',
    // backgroundColor: 'pink',
  },
  marginContainer: {
    marginHorizontal: 10,
  },
  photosContainer: {
    marginBottom: 20
  },
  logoContainer: {
    // aspectRatio: 16 / 9,
    marginBottom: 10,
  },
  projectImage: {
    
  },
  defaultProjectImage: {
    aspectRatio: 339 / 158,
  },
  gradient: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    height: '100%',
  },
  buttonsOverlay: {
    position: 'absolute',
    top: Platform.OS === 'web' ? 5 : 40,
    left: 0,
    width: '100%',
    padding: 15,
    flexDirection: 'row',
    alignItems: 'center',
  },
  editButton: {
    marginLeft: 'auto',
    // marginRight: 15,
  },
  projectPhotoButtonContainer: {
    position:'absolute',
    bottom: 20,
    right: 20,
  },
  section: {
    marginBottom: 20,
  },
  gallery: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    // justifyContent: 'space-between',
    // flex: 1,
  },
  thumbContainer: {
    borderRadius: 5,
    flex: 1,
    flexBasis: '23.5%',
    flexGrow: 0,
    marginRight: '2%',
    marginBottom: '2%',
  },
  thumbContainerNoRightMargin: {
    borderRadius: 5,
    flex: 1,
    flexBasis: '23.5%',
    flexGrow: 0,
    marginRight: 0,
    marginBottom: '2%',
  },
  thumb: {
    aspectRatio: 150 / 150,
    borderRadius: 5,
  },
  inputLabel: {
    marginBottom: 7,
  },
  description: {
    height: 140,
    textAlignVertical: 'top',
  },
  photos: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 20,
  },
  photoTitleContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
  },
  newPhotoContainer: {
    backgroundColor: Colors.yellow,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center'
  },
  photoPlus: {
    position:'absolute',
  },
  // photoButtons: {
  //   marginLeft: 'auto',
  //   flexDirection: 'row',
  // },
  // photoButton: {
  //   flexDirection: 'row',
  //   backgroundColor: Colors.yellow,
  //   padding: 5,
  //   borderRadius: 10,
  //   alignItems: 'center',
  // },
  // photoButtonText: {
  //   fontSize: 18,
  //   marginLeft: 5,
  // },
  newMilestoneContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    // paddingTop: 10,
    marginBottom: 20,
  },
  newMilestoneText: {
    marginVertical: 0,
    marginLeft:10,
  },
  inviteTile: {
    borderWidth: 1,
    borderColor: Colors.lightBlue,
    borderRadius: 10,
    padding: 15,
    flexDirection: 'row',
    alignItems: 'center',
    marginHorizontal: 10,
    marginBottom: 20,
    backgroundColor: Colors.textInputBackground,
  },
  contractorTile: {
    borderWidth: 1,
    borderColor: Colors.lightBlue,
    borderRadius: 10,
    marginHorizontal: 10,
    marginBottom: 20,
    backgroundColor: Colors.textInputBackground,
  },
  contractorTileInner: {
    padding: 15,
    flexDirection: 'row',
    alignItems: 'center',
  },
  feeTile: {
    borderWidth: 1,
    borderColor: Colors.lightBlue,
    borderRadius: 10,
    padding: 15,
    marginHorizontal: 10,
    marginBottom: 20,
    backgroundColor: Colors.textInputBackground,
  },
  contractorAvatar: {
    marginRight: 10,
  },
  tabButtonContainer: {
    marginVertical: 15, 
  },
  acceptCreditCardsContainer: {
    marginBottom: 20,
  },
  avatarContainer: {
    // borderRadius: 100,
    // overflow: 'hidden',
    // borderStyle: 'solid',
    // borderWidth: 5,
    // borderColor: Colors.lightBlue2,
    marginRight: 20,
  },
  avatar: {
    width: 80,
    height: 80,
  },
  // view
  mainImageInfoOverlay: {
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: '100%',
    padding: 10,
  },
  progressBar: {
    height: 12,
    borderRadius: 10,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    position: 'absolute'
  },
  fundBar: {
    // backgroundColor: Colors.lightBlue2,
    backgroundColor: Colors.green,
  },
  releaseBar: {
    backgroundColor: Colors.yellow,
  },
  totalBar: {
    backgroundColor: Colors.lightGrey,
    height: 12,
    width: '100%',
    borderRadius: 10,
    borderTopRightRadius: 10,
    borderBottomRightRadius: 10,
  },
  playVideoContainer: {
    marginVertical: 10,
  },
  video: {
    alignSelf: 'center',
    width: '100%',
    height: 'auto',
    maxWidth: 768,
    maxHeight: 432,
    marginBottom: 20,
    borderRadius: 10,
    borderColor: Colors.lightBlue,
    borderWidth: 1,
    ...Platform.select({
      ios: {
        aspectRatio: 1920 / 1080,
      },
      android: {
        aspectRatio: 1920 / 1080,
      },
    })
  },
  orderMilestoneContainer: {
    marginVertical: 5,
  },
  orderMilestoneCompleted: {
    borderWidth: 1,
    borderColor: Colors.lightBlue2,
    padding: 10,
    borderRadius: 10,
    flexGrow: 1,
    // flexWrap: 'wrap',
    flex: 1,
    // marginVertical: 5,
  },
  orderMilestoneNotCompleted: {
    backgroundColor: Colors.lightBlue2,
  },
  orderMilestoneActive: {
    backgroundColor: Colors.yellow,
    borderColor: Colors.yellow,
    transform: [{ scale: 1.05 }],
    opacity: 0.7,
    borderRadius: 10,
  },
  lockIcon: {
    position: 'absolute',
    top:5,
    right:5,
  }
});

export default ProjectScreen;